<template>
  <div>
    <div class="hide-footer clearfix" v-if="true">
      <div class="c-footer-collective">
        <div
          class="c-footer-collective__top o-section--default bg-clr--darkest-gray u-font-size--small"
          v-if="club"
          :style="`background-color: ${
            club.ColorFooterPredeterminado
              ? 'white'
              : `#${club.ColorSecundarioHex}`
          }; color: #${club.ColorPrimarioHex};`"
        >
          <div class="o-container o-container--large">
            <div
              class="o-layout o-layout--stretch o-layout--gutter-big o-block mb-10"
            >
              <div class="o-layout__item o-block__item o-block u-1/3@sm">
                <b class="o-block__item u-font-size--default">{{
                  $func.parseIso("agency")
                }}</b>
                <div class="o-block__item c-footer-collective__box-brand">
                  <div
                    id="j_id_4m_3:collective-img__container"
                    class="c-collective-brand c-collective-brand--footer o-section--small"
                  >
                    <a
                      class="c-collective-brand__link o-box--tiny u-display--inline-block"
                    >
                      <img
                        @click="reloadTo('/')"
                        class="c-collective-brand__img"
                        style="cursor: pointer;"
                        :src="club.Logo"
                      />
                      <!-- <br> -->
                      <img
                        @click="priceMatch = true"
                        style="
                          margin-left: 5em;
                          width: 20%;
                          height: 40%;
                          cursor: pointer;
                        "
                        class="c-collective-brand__img"
                        src="https://www.shutterstock.com/image-vector/best-price-sale-grunge-rubber-600nw-2262495703.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div class="o-block__item"></div>
              </div>
              <div class="o-layout__item o-block__item o-block u-1/3@sm">
                <b class="o-block__item u-font-size--default">
                  {{ $func.parseIso("contact") }}
                </b>
                <div class="o-block__item o-group--tiny">
                  <i
                    class="fa-regular fa-map-marker-alt clr--brand footer-icon"
                  ></i
                  ><span> {{ club.Direccion_Footer || club.Direccion }} </span>
                </div>
                <div class="o-block__item o-group--tiny">
                  <i class="fa-regular fa-phone clr--brand footer-icon"></i
                  ><span>{{
                    club.Telefono_Footer || club.Telefono || ""
                  }}</span>
                </div>
                <div
                  class="o-block__item o-group--tiny u-text-transform--lowercase"
                >
                  <i class="fa-regular fa-envelope clr--brand footer-icon"></i>
                  <span>
                    {{ club.Email_Footer || club.Email }}
                  </span>
                </div>
              </div>
              <div class="o-layout__item o-block__item o-block u-1/3@sm">
                <b class="o-block__item u-font-size--default">{{
                  $func.parseIso("interestedLinks")
                }}</b>
                <p
                  class="o-block__item"
                  style="cursor: pointer"
                  @click="termsShow = true"
                >
                  {{ $func.parseIso("termsAndConditions") }}
                </p>
                <p
                  class="o-block__item"
                  style="cursor: pointer"
                  @click="cookiesShow = true"
                >
                  {{ $func.parseIso("cookiesPolicy") }}
                </p>
                <span class="o-block__item"
                  >@ Copyright {{ year }} | {{ v }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="c-footer-collective__bottom bg-clr--white p-20 pb-0 p-5@sm pb-0@sm"
        >
          <div
            class="o-flexbox o-flexbox--generic-row o-group--small u-justify-content--center u-align-items--center u-flex-wrap--wrap"
          >
            <div class="pb-20 pb-5@sm">
              <img
                data-src="https://booking.vacancyrewards.com/img/branding/stripe/stripe_payments.jpg"
                src="https://booking.vacancyrewards.com/img/branding/stripe/stripe_payments.jpg"
                data-index=""
                data-error-src="https://booking.vacancyrewards.com/javax.faces.resource/images/no-photo-XS.jpg"
                onerror="this.setAttribute('data-original-url', this.src); var errorUrl = this.getAttribute('data-error-src'); if(this.src !== errorUrl) {this.src = errorUrl};"
                loading="lazy"
                alt="Stripe"
                width=""
                height="25px"
                onclick=""
                style=""
                class="lazy-img loaded"
                data-ll-status="loaded"
              />
            </div>
            <div class="pb-20 pb-5@sm"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="hide-footer clearfix" v-else>
      <footer id="generic-MS-footer" class="ms-footer">
        <div class="top-footer">
          <div class="o-container o-container--large">
            <div class="o-section--bigger o-layout" style="display: flex">
              <div
                class="o-layout__item u-1/3@sm u-text-align--center u-text-align--left@sm ms-footer__column ms-footer__column--brand"
              >
                <a class="ms-brand">
                  <p class="u-font-size--0">
                    <span>Vacancy Rewards</span>
                  </p>
                  <img
                    src="https://booking.vacancyrewards.com/css/clientes/vacancyrewards/images/brand-primary-white.png"
                    alt="brand"
                    class="img-brand"
                  />
                </a>
              </div>
              <div
                class="o-layout__item u-1/3@sm u-text-align--center ms-footer__column ms-footer__column--social"
              >
                <div class="c-rrss-icons c-rrss-icons--">
                  <span class="tc-subtitle">{{
                    $func.parseIso("socialNetworks")
                  }}</span>
                  <a
                    href="https://www.facebook.com/VacancyRewards"
                    target="_blank"
                    class="c-rrss-icons__facebook"
                    rel="noopener"
                    ><i class="fab fa-facebook"></i
                  ></a>
                  <a
                    href="https://www.vacancyrewards.com"
                    class="c-rrss-icons__home"
                    target="_blank"
                    rel="noopener"
                    ><i class="fa-regular fa-home"></i
                  ></a>
                  <a
                    href="https://www.instagram.com/vacancyrewardsofc/"
                    class="c-rrss-icons__instagram"
                    target="_blank"
                    rel="noopener"
                    ><i class="fab fa-instagram"></i
                  ></a>
                </div>
              </div>
              <div
                class="o-layout__item u-1/3@sm u-text-align--center u-text-align--right@sm ms-footer__column ms-footer__column--contact"
              >
                <span class="tc-subtitle">{{ $func.parseIso("contact") }}</span>
                <ul class="list-contact">
                  <li><b>Vacancy Rewards</b></li>
                  <li>
                    <i class="fa-regular fa-map-marker-alt"></i> 2688 SW 137
                    Avenue. Miami, Florida
                  </li>
                  <li>33175 - Miami</li>
                  <li>
                    <em><i class="fa-regular fa-phone"></i> Teléfono: </em>
                    +18772123834
                  </li>
                  <li>
                    <em><i class="fab fa-whatsapp"></i> WhatsApp: </em>
                    +529982666984
                  </li>
                  <li>
                    <em
                      ><i class="fa-regular fa-envelope"></i> Correo
                      electrónico: </em
                    ><a href="mailto:reservations@vacancyrewards.com">
                      reservations@vacancyrewards.com</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-footer o-section--small">
          <div class="o-container o-container--large">
            <div
              class="footer-bottom-bar o-group--small u-text-align--center u-text-align--right@md"
            >
              <span class="copyright bottom-footer__span"
                >© Copyright {{ year }}</span
              >
              <span class="bottom-footer__span"> | </span
              ><span class="cookies"
                ><a
                  class="link fakeLink bottom-footer__link"
                  data-toggle="modal"
                  data-target=".cookiesPolicy"
                  style="cursor: pointer"
                  @click="cookiesShow = true"
                  >{{ $func.parseIso("cookiesPolicy") }}</a
                ></span
              >
              <span class="bottom-footer__span"> | </span
              ><span class="privacidad"
                ><a
                  class="link fakeLink bottom-footer__link"
                  data-toggle="modal"
                  data-target=".privacyPolicy"
                  @click="termsShow = true"
                  style="cursor: pointer"
                  >{{ $func.parseIso("termsAndConditions") }}</a
                ></span
              >
            </div>
          </div>
        </div>
        <div
          class="c-footer-collective__bottom bg-clr--white p-20 pb-0 p-5@sm pb-0@sm"
        >
          <div
            class="o-flexbox o-flexbox--generic-row o-group--small u-justify-content--center u-align-items--center u-flex-wrap--wrap"
          >
            <div class="pb-20 pb-5@sm">
              <img
                data-src="https://booking.vacancyrewards.com/img/branding/stripe/stripe_payments.jpg"
                src="https://booking.vacancyrewards.com/img/branding/stripe/stripe_payments.jpg"
                data-index=""
                data-error-src="https://booking.vacancyrewards.com/javax.faces.resource/images/no-photo-XS.jpg"
                onerror="this.setAttribute('data-original-url', this.src); var errorUrl = this.getAttribute('data-error-src'); if(this.src !== errorUrl) {this.src = errorUrl};"
                loading="lazy"
                alt="Stripe"
                width=""
                height="25px"
                onclick=""
                style=""
                class="lazy-img loaded"
                data-ll-status="loaded"
              />
            </div>
            <div class="pb-20 pb-5@sm"></div>
          </div>
        </div>
      </footer>
    </div>
    <div
      class="c-modal privacyPolicy c-modal-cookies-privacy"
      data-size="large"
      role="dialog"
      data-closeable="true"
      tabindex="-1"
      aria-modal="true"
      data-active="true"
      style="display: block; z-index: 2050; width: 100%"
      v-if="termsShow"
    >
      <div class="c-modal__backmask"></div>
      <div class="c-modal__wrapper">
        <div class="c-modal__container">
          <!-- <div class="c-modal__close" style="">
            <button
              type="button"
              class="c-modal__close-btn"
              data-dismiss="modal"
              @click="termsShow = false"
              v-if="!showBtnTerms"
            >
              <span
                class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
              >
                {{ $func.parseIso("close") }}
                <i
                  class="fa-solid fa-caret-right u-font-size--default"
                ></i></span
              ><i class="u-display--block fa-regular fa-close"></i>
            </button>
          </div> -->
          <div class="c-modal__body">
            <!-- <div
              class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
            >
              {{ $func.parseIso("termsAndConditions") }}
            </div> -->
            <div
              class="privacy_policy"
              v-html="iso === 'es' ? TERMS_ES : TERMS_EN"
            ></div>
          </div>
          <table style="width: 100%">
            <tr>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <td style="padding: 1%">
                <a
                  class="original-button cancel-terms"
                  @click="acceptAllTerms(false)"
                  v-if="showBtnTerms"
                  >{{ $func.parseIso("cancel") }}</a
                >
              </td>
              <td style="padding: 1%">
                <a
                  @click="acceptAllTerms(true)"
                  class="original-button accept-terms"
                  v-if="showBtnTerms"
                  >{{ $func.parseIso("iAccept") }}</a
                >
              </td>
              <td style="padding: 1%">
                <a
                  @click="termsShow = false"
                  class="original-button close-terms"
                  v-if="!showBtnTerms"
                  >{{ $func.parseIso("close") }}</a
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div
      id="j_id_4b_3w:cookiesPolicy"
      class="c-modal cookiesPolicy"
      data-size="medium"
      role="dialog"
      data-closeable="false"
      tabindex="-1"
      aria-modal="true"
      data-active="true"
      style="display: block; z-index: 1050; width: 100%"
      v-if="cookiesShow"
    >
      <div class="c-modal__backmask"></div>
      <div class="c-modal__wrapper">
        <div class="c-modal__container">
          <div class="c-modal__close" style="">
            <button
              type="button"
              class="c-modal__close-btn"
              data-dismiss="modal"
              @click="cookiesShow = false"
            >
              <span
                class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
              >
                {{ $func.parseIso("close") }}
                <i
                  class="fa-solid fa-caret-right u-font-size--default"
                ></i></span
              ><i class="u-display--block fa-regular fa-close"></i>
            </button>
          </div>
          <div class="c-modal__body">
            <div
              class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
            >
              {{ $func.parseIso("cookiesPolicy") }}
            </div>
            <form
              id="j_id_4b_3w:cookies-consent-form"
              name="j_id_4b_3w:cookies-consent-form"
              class="c-modal-cookies-consent"
            >
              <div id="box-cookies-main" class="box-cookies-consent">
                <div class="o-block">
                  <div class="o-block__item">
                    {{ $func.parseIso("cookiesPolicy__msg1") }}
                  </div>
                  <div
                    class="o-block o-block--small o-layout o-layout--gutter-small o-block--item u-text-align--center u-text-align--right@sm"
                  >
                    <!-- <div class="o-block__item o-layout__item u-display--inline">
                      <input
                        id="j_id_4b_3w:cookies-consent-form:rejectAllMain"
                        name="j_id_4b_3w:cookies-consent-form:rejectAllMain"
                        type="button"
                        value="Reject all"
                        onclick="rejectAllCookies()"
                        class="c-button bg-clr--brand--alpha-soft dev-reject-all"
                      />
                    </div> -->
                    <div
                      class="o-block__item o-layout__item u-display--inline u-text-align--right"
                    >
                      <input
                        id="j_id_4b_3w:cookies-consent-form:acceptAllMain"
                        name="j_id_4b_3w:cookies-consent-form:acceptAllMain"
                        type="button"
                        :value="$func.parseIso('accept')"
                        @click="cookiesShow = false"
                        class="c-button bg-clr--brand dev-accept-all mb-5 mb-0@sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      id="j_id_4b_6h:privacyPolicy"
      class="c-modal privacyPolicy c-modal-cookies-privacy"
      data-size="large"
      role="dialog"
      data-closeable="true"
      tabindex="-1"
      aria-modal="true"
      data-active="true"
      style="display: block; z-index: 1050; width: 100%"
      v-if="priceMatch"
    >
      <div class="c-modal__backmask"></div>
      <div class="c-modal__wrapper">
        <div class="c-modal__container">
          <div class="c-modal__close" style="">
            <button
              type="button"
              class="c-modal__close-btn"
              data-dismiss="modal"
              @click="priceMatch = false"
            >
              <span
                class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
              >
                {{ $func.parseIso("close") }}
                <i
                  class="fa-solid fa-caret-right u-font-size--default"
                ></i></span
              ><i class="u-display--block fa-regular fa-close"></i>
            </button>
          </div>
          <div class="c-modal__body">
            <div
              class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
            >
              Warranty policies
              <!-- {{ $func.parseIso("termsAndConditions") }} -->
            </div>
            <div
              class="privacy_policy"
              v-html="iso === 'es' ? PRICEMATCH_ES : PRICEMATCH_EN"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Verificacion de datos -->
    <div
      class="c-modal cookiesPolicy"
      data-size="medium"
      role="dialog"
      data-closeable="false"
      tabindex="-1"
      aria-modal="true"
      data-active="true"
      style="display: block; z-index: 1050; width: 100%"
      v-if="dataVerification"
    >
      <div class="c-modal__backmask"></div>
      <div class="c-modal__wrapper">
        <div class="c-modal__container">
          <div class="c-modal__close" style="">
            <button
              type="button"
              class="c-modal__close-btn"
              data-dismiss="modal"
            >
              <span
                class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
              >
                Cerrar
                <i
                  class="fa-solid fa-caret-right u-font-size--default"
                ></i></span
              ><i class="fa-regular fa-close"></i>
            </button>
          </div>
          <div class="c-modal__body">
            <h2
              class="c-modal__header u-font-weight--600 u-line-height--1 m-0 u-hide-empty"
              v-if="showDataUpdate"
            >
              {{ $func.parseIso("dataUpdate") }}
            </h2>
            <div class="o-block o-block--small">
              <div
                class="o-block__item o-layout o-layout--gutter-small mb-0"
                v-if="showDataUpdate"
              >
                <div
                  class="c-modal-more-info-idea__name o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("name") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <input
                      type="text"
                      v-model="dataUpdate.Nombre"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input name-input ui-state-filled"
                      aria-required="true"
                      data-field="name"
                      style="padding-right: 10px !important"
                      maxlength="100"
                    />
                    <!-- <b-input v-model="dataUpdate.Nombre"></b-input> -->
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__surname o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("lastname") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <input
                      type="text"
                      v-model="dataUpdate.ApellidoPaterno"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input u-1/1 lastName-input ui-state-filled"
                      aria-required="true"
                      data-field="surname"
                      style="padding-right: 10px !important"
                      maxlength="100"
                    />
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__mail o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("email") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <input
                      id="emailUpdateData"
                      type="email"
                      v-model="dataUpdate.Email"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input contactEmail-input u-1/1 ui-state-filled"
                      aria-required="true"
                      data-p-val="Size"
                      disabled
                      style="padding-right: 10px !important"
                      maxlength="255"
                    />
                  </div>
                </div>
              </div>
              <div
                class="o-block__item o-layout o-layout--gutter-small mb-0"
                v-if="showDataUpdate"
              >
                <div
                  class="c-modal-more-info-idea__phone o-layout__item u-1/2@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("cellphone") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <div class="currency-container">
                      <select
                        class="currency-select"
                        v-model="dataUpdate.LadaTelefono"
                      >
                        <option :value="null">🌎 +?</option>
                        <option
                          :value="pais.Lada"
                          v-for="pais in Cat.CatPaises"
                        >
                          {{ pais.Id }} +{{ pais.Lada }}
                        </option>
                      </select>
                      <input
                        type="text"
                        class="currency-input"
                        v-mask="'(###) ###-##-###'"
                        placeholder="(___) ___-__-___"
                        v-model="dataUpdate.Telefono"
                        maxlength="20"
                      />
                    </div>
                    <!-- <input
                      id="contactToBook:phone"
                      name="contactToBook:phone"
                      type="text"
                      v-model="dataUpdate.Telefono"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input phone-input u-1/1"
                    /> -->
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__phone o-layout__item u-1/2@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("phone") }}
                  </b>
                  <div class="c-icon-escort">
                    <div class="currency-container">
                      <select
                        class="currency-select"
                        v-model="dataUpdate.LadaCelular"
                      >
                        <option :value="null">🌎 +?</option>
                        <option
                          :value="pais.Lada"
                          v-for="pais in Cat.CatPaises"
                        >
                          {{ pais.Id }} +{{ pais.Lada }}
                        </option>
                      </select>
                      <input
                        type="text"
                        class="currency-input"
                        v-mask="'(###) ###-##-####'"
                        placeholder="(___) ___-__-___"
                        v-model="dataUpdate.Celular"
                        maxlength="20"
                      />
                    </div>
                    <!-- <input
                      id="slt"
                      name="contactToBook:phone"
                      type="text"
                      v-model="dataUpdate.Celular"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input phone-input u-1/1"
                      v-mask="'+? (###) ###-##-##'"
                      placeholder="+? (___) ___-__-__"
                    /> -->
                  </div>
                </div>
              </div>
              <div
                class="o-block__item o-layout o-layout--gutter-small mb-0"
                v-if="showDataUpdate"
              >
                <div
                  class="c-modal-more-info-idea__mail o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("country") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <div class="c-sb-input__addicon--drop">
                      <select
                        id="j_id_6v:init-compositor-all:nights"
                        name="j_id_6v:init-compositor-all:nights"
                        size="1"
                        class="c-sb-input__field u-1/1 select-custom"
                        v-model="dataUpdate.Pais"
                      >
                        <option :value="null"></option>
                        <option :value="pais.Id" v-for="pais in Cat.CatPaises">
                          {{ pais.NombreEn }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__mail o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("state") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <div class="c-sb-input__addicon--drop">
                      <select
                        id="j_id_6v:init-compositor-all:nights"
                        name="j_id_6v:init-compositor-all:nights"
                        size="1"
                        class="c-sb-input__field u-1/1 select-custom"
                        v-model="dataUpdate.Estado"
                      >
                        <option :value="null"></option>
                        <option
                          :value="estado.Id"
                          v-for="estado in dataUpdate.Pais
                            ? Cat.CatEstadosPais.filter(
                                (e) => e.PaisId === dataUpdate.Pais
                              )
                            : []"
                        >
                          {{ estado.NombreEng }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__name o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("city") }}
                  </b>
                  <div class="c-icon-escort">
                    <input
                      type="text"
                      v-model="dataUpdate.Ciudad"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input name-input ui-state-filled"
                      aria-required="true"
                      data-field="name"
                      style="padding-right: 10px !important"
                      maxlength="100"
                    />
                  </div>
                </div>
              </div>
              <div
                class="o-block__item o-layout o-layout--gutter-small mb-0"
                v-if="showDataUpdate"
              >
                <div
                  class="c-modal-more-info-idea__surname o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("address") }}
                  </b>
                  <div class="c-icon-escort">
                    <input
                      type="text"
                      v-model="dataUpdate.Direccion"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input u-1/1 lastName-input ui-state-filled"
                      aria-required="true"
                      data-field="surname"
                      style="padding-right: 10px !important"
                      maxlength="200"
                    />
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__name o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("zip") }}
                  </b>
                  <div class="c-icon-escort">
                    <input
                      id="zipUpdateData"
                      type="text"
                      v-model="dataUpdate.CodigoPostal"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input name-input ui-state-filled"
                      aria-required="true"
                      data-field="name"
                      placeholder="#####-####"
                      v-mask="'#####-####'"
                      style="padding-right: 10px !important"
                      maxlength="20"
                    />
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__mail o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("nacionality") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <div class="c-sb-input__addicon--drop">
                      <select
                        id="j_id_6v:init-compositor-all:nights"
                        name="j_id_6v:init-compositor-all:nights"
                        size="1"
                        class="c-sb-input__field u-1/1 select-custom"
                        v-model="dataUpdate.Nacionalidad"
                      >
                        <option :value="null"></option>
                        <option :value="pais.Id" v-for="pais in Cat.CatPaises">
                          {{ pais.NacionalidadEn }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="o-block__item o-layout o-layout--gutter-small mb-0"
                v-if="showDataUpdate"
              >
                <div
                  class="c-modal-more-info-idea__phone o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("birthdate") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <input
                      type="date"
                      v-model="dataUpdate.FechaNacimiento"
                      class="ui-inputfield ui-inputtext ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input phone-input u-1/1"
                      style="padding-right: 10px !important"
                    />
                    <!-- <i
                      class="c-icon-escort__icon fa-regular fa-calendar"
                      aria-hidden="true"
                    ></i> -->
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__mail o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("gender") }}
                  </b>
                  <div class="c-icon-escort">
                    <div class="c-sb-input__addicon--drop">
                      <select
                        class="c-sb-input__field u-1/1 select-custom"
                        v-model="dataUpdate.Genero"
                      >
                        <option value="M">{{ $func.parseIso("male") }}</option>
                        <option value="F">
                          {{ $func.parseIso("female") }}
                        </option>
                        <option value="O">{{ $func.parseIso("other") }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__mail o-layout__item u-1/3@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("preferablyLanguage") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <div class="c-sb-input__addicon--drop">
                      <select
                        size="1"
                        class="c-sb-input__field u-1/1 select-custom"
                        v-model="dataUpdate.Idioma"
                      >
                        <option :value="null"></option>
                        <option
                          :value="idioma.Id"
                          v-for="idioma in Cat.CatIdiomas"
                        >
                          {{ idioma.NombreEn }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <br v-if="showUpdatePassword" />
              <h2
                class="c-modal__header u-font-weight--600 u-line-height--1 m-0 u-hide-empty"
                v-if="showUpdatePassword"
              >
                {{ $func.parseIso("updatePassword") }}
              </h2>
              <div
                class="o-block__item o-layout o-layout--gutter-small mb-0"
                v-if="showUpdatePassword"
              >
                <div
                  class="c-modal-more-info-idea__name o-layout__item u-1/2@sm mb-10"
                >
                  <b class="u-font-size--small">
                    {{ $func.parseIso("password") }}
                    <span style="color: #e62727">*</span>
                  </b>
                  <div class="c-icon-escort">
                    <span
                      class="ui-password ui-password-masked ui-inputwrapper ui-input-icon-right"
                      style="cursor: pointer"
                    >
                      <input
                        v-model="newpassword"
                        :type="isShowPass ? 'text' : 'password'"
                        class="ui-inputfield ui-widget ui-state-default ui-corner-all c-icon-escort__main c-text-input login-password-input" />
                      <i
                        id="login-form:login-content:login:j_password_mask"
                        :class="!isShowPass ? 'pi pi-eye' : 'pi pi-eye-slash'"
                        @click="isShowPass = !isShowPass"
                      >
                      </i
                    ></span>
                  </div>
                </div>
                <div
                  class="c-modal-more-info-idea__name o-layout__item u-1/2@sm mb-10"
                >
                  <b
                    class="u-font-size--small"
                    style="color: white; cursor: default"
                  >
                    {{ $func.parseIso("password") }}
                  </b>
                  <div class="c-icon-escort" style="font-size: 75%">
                    <div class="o-layout__item u-1/3@sm">
                      <ul class="ul-pass">
                        <li class="li-pass">
                          <span class="icon-pass">{{
                            checkPassRegex(1) ? "✅" : "❌"
                          }}</span>
                          {{ $func.parseIso("checkPass__1") }}
                        </li>
                        <li class="li-pass">
                          <span class="icon-pass">{{
                            checkPassRegex(2) ? "✅" : "❌"
                          }}</span>
                          {{ $func.parseIso("checkPass__2") }}
                        </li>
                      </ul>
                    </div>
                    <div class="o-layout__item u-1/3@sm">
                      <ul class="ul-pass">
                        <li class="li-pass">
                          <span class="icon-pass">{{
                            checkPassRegex(3) ? "✅" : "❌"
                          }}</span>
                          {{ $func.parseIso("checkPass__3") }}
                        </li>
                        <li class="li-pass">
                          <span class="icon-pass">{{
                            checkPassRegex(4) ? "✅" : "❌"
                          }}</span>
                          {{ $func.parseIso("checkPass__4") }}
                        </li>
                      </ul>
                    </div>
                    <div class="o-layout__item u-1/3@sm">
                      <ul class="ul-pass">
                        <li class="li-pass">
                          <span class="icon-pass">{{
                            checkPassRegex(5) ? "✅" : "❌"
                          }}</span>
                          {{ $func.parseIso("checkPass__5") }}
                        </li>
                        <li class="li-pass">
                          <span class="icon-pass">{{
                            checkPassRegex(6) ? "✅" : "❌"
                          }}</span>
                          {{ $func.parseIso("checkPass__6") }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <!-- MENSAJE DE ERRORES -->
              <div class="o-block__item mb-0" v-if="errorUpdateData">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("mandatoryField__msg1") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>

              <div class="o-block__item mb-0" v-if="errorUpdateDataPhone">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("mandatoryField__msg2") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>

              <div class="o-block__item mb-0" v-if="errorUpdateDataEmail">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("mandatoryField__msg3") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>

              <div class="o-block__item mb-0" v-if="errorTermsAccept">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("acceptTerms") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>

              <div class="o-block__item mb-0" v-if="errorUpdatePassword">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("mandatoryUpdatePassword") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>

              <div class="o-block__item mb-0" v-if="errorValidatePassword">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("changePassword__msg3") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>

              <div class="o-block__item mb-0" v-if="errorInternal">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm center-all"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray" style="color: #e62727">
                      {{ $func.parseIso("internalError") }}.</span
                    >
                  </div>
                </div>
                <br />
              </div>
              <!-- MENSAJE DE ERRORES -->

              <div class="o-block__item mb-0" v-if="showDataUpdate">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm"
                >
                  <div
                    class="c-modal-more-info-idea__options u-font-size--small mr-10@sm mb-10"
                  >
                    <span class="clr--darker-gray"
                      >(<span style="color: #e62727">*</span>)
                      {{ $func.parseIso("mandatoryField") }}.</span
                    >
                    <!-- <br />
                    <span class="clr--darker-gray">{{
                      $func.parseIso("updateData__note1")
                    }}</span> -->
                  </div>
                </div>
              </div>
              <div class="o-block__item mb-0" v-if="showTermsField">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm"
                >
                  <div class="o-block__item o-position--relative">
                    <div class="o-flexbox o-group--tiny">
                      <div
                        class="ui-selectbooleancheckbox ui-chkbox ui-widget dev-hotelFilter-refundable dev-filter-title pr-40 u-1/1"
                      >
                        <div class="ui-helper-hidden-accessible">
                          <input
                            type="checkbox"
                            aria-label="Free cancellation"
                            data-p-con="javax.faces.Boolean"
                            data-p-hl="booleanchkbox"
                          />
                        </div>
                        <div
                          :class="`ui-chkbox-box ui-widget ui-corner-all ui-state-default ${
                            dataUpdate.TerminosYCondiciones
                              ? 'ui-state-active'
                              : ''
                          }`"
                          @click="
                            dataUpdate.TerminosYCondiciones =
                              !dataUpdate.TerminosYCondiciones
                          "
                        >
                          <span
                            class="ui-chkbox-icon ui-icon ui-icon-check ui-c"
                            v-if="dataUpdate.TerminosYCondiciones"
                          ></span>
                          <span
                            class="ui-chkbox-icon ui-icon ui-icon-blank ui-c"
                            v-else
                          ></span>
                        </div>
                        <span
                          class="ui-chkbox-label"
                          style="font-size: 90%; cursor: default"
                          v-if="iso === 'es'"
                          >He leído y entiendo que al confirmar mi informacion
                          acepto sus
                          <span
                            style="color: #0472aa; cursor: pointer"
                            @click="termsShow = true"
                            >Términos y Condiciones</span
                          >
                          y
                          <span
                            style="color: #0472aa; cursor: pointer"
                            @click="cookiesShow = true"
                            >Aviso de Privacidad</span
                          >.</span
                        >
                        <span
                          class="ui-chkbox-label"
                          style="font-size: 90%; cursor: default"
                          v-else
                          >I have read and understand that by confirming my
                          information, I accept your
                          <span
                            style="color: #0472aa; cursor: pointer"
                            @click="termsShow = true"
                            >Terms & Conditions</span
                          >
                          and
                          <span
                            style="color: #0472aa; cursor: pointer"
                            @click="cookiesShow = true"
                            >Privacy Policy</span
                          >.</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <br />
              </div>
              <div class="o-block__item mb-0" v-if="showDataUpdate">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm"
                >
                  <div class="o-block__item o-position--relative">
                    <div class="o-flexbox o-group--tiny">
                      <div
                        class="ui-selectbooleancheckbox ui-chkbox ui-widget dev-hotelFilter-refundable dev-filter-title pr-40 u-1/1"
                        @click="
                          dataUpdate.RecibirBoletines =
                            !dataUpdate.RecibirBoletines
                        "
                      >
                        <div class="ui-helper-hidden-accessible">
                          <input
                            type="checkbox"
                            aria-label="Free cancellation"
                            data-p-con="javax.faces.Boolean"
                            data-p-hl="booleanchkbox"
                          />
                        </div>
                        <div
                          :class="`ui-chkbox-box ui-widget ui-corner-all ui-state-default ${
                            dataUpdate.RecibirBoletines ? 'ui-state-active' : ''
                          }`"
                        >
                          <span
                            class="ui-chkbox-icon ui-icon ui-icon-check ui-c"
                            v-if="dataUpdate.RecibirBoletines"
                          ></span>
                          <span
                            class="ui-chkbox-icon ui-icon ui-icon-blank ui-c"
                            v-else
                          ></span>
                        </div>
                        <span class="ui-chkbox-label" style="font-size: 90%">{{
                          $func.parseIso("updateData__note2")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="o-block__item mb-0">
                <div
                  class="o-flexbox@sm o-flexbox--generic-row@sm u-align-items--start@sm"
                >
                  <a
                    id="contactToBook:send"
                    class="ui-commandlink ui-widget c-modal-more-info-idea__button u-1/1 u-width--auto@sm c-button c-button-sm bg-clr--brand send-button"
                    style="background-color: #44444e"
                    @click="exitWithoutSaving"
                    v-if="btnExit === 'login'"
                  >
                    {{ $func.parseIso("notSave") }}
                  </a>
                  <a
                    id="contactToBook:send"
                    class="ui-commandlink ui-widget c-modal-more-info-idea__button u-1/1 u-width--auto@sm c-button c-button-sm bg-clr--brand send-button"
                    style="background-color: #44444e"
                    @click="dataVerification = false"
                    v-if="btnExit === 'close'"
                  >
                    {{ $func.parseIso("notSave") }}
                  </a>
                  <a
                    id="contactToBook:send"
                    :class="`ui-commandlink ui-widget c-modal-more-info-idea__button u-1/1 u-width--auto@sm c-button c-button-sm bg-clr--brand send-button ${
                      loadingSaveData ? 'loader-spn' : ''
                    }`"
                    style="background-color: #5ebb3f"
                    @click="updateData()"
                    v-if="btnSave === 'saveData'"
                  >
                    {{
                      loadingSaveData
                        ? $func.parseIso("saving")
                        : $func.parseIso("save")
                    }}
                  </a>
                  <a
                    id="contactToBook:send"
                    :class="`ui-commandlink ui-widget c-modal-more-info-idea__button u-1/1 u-width--auto@sm c-button c-button-sm bg-clr--brand send-button ${
                      loadingChangePassword ? 'loader-spn' : ''
                    }`"
                    style="background-color: #5ebb3f"
                    @click="changePasswordManual()"
                    v-if="btnSave === 'saveNewPass'"
                  >
                    {{
                      loadingChangePassword
                        ? $func.parseIso("saving")
                        : $func.parseIso("save")
                    }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const PRICEMATCH_ES = `<!DOCTYPE html>
<html lang="en-US">
	<head>
<meta name="viewport" content="width=device-width, initial-scale=1.0">
		<meta charset="utf-8" />
		<title>
		</title>
		<style>
			body { line-height:115%; font-family:Arial; font-size:11pt }
			h1, h2, h3, h4, h5, h6, p { margin:0pt }
			li { margin-top:0pt; margin-bottom:0pt }
			h1 { margin:20pt 0pt 6pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:20pt; font-weight:normal; font-style:normal; text-decoration:none; color:#000000 }
			h2 { margin:18pt 0pt 6pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:16pt; font-weight:normal; font-style:normal; text-decoration:none; color:#000000 }
			h3 { margin:16pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:14pt; font-weight:normal; font-style:normal; text-decoration:none; color:#434343 }
			h4 { margin:14pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:12pt; font-weight:normal; font-style:normal; text-decoration:none; color:#666666 }
			h5 { margin:12pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:11pt; font-weight:normal; font-style:normal; text-decoration:none; color:#666666 }
			h6 { margin:12pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:11pt; font-weight:normal; font-style:italic; text-decoration:none; color:#666666 }
			.Subtitle { margin:0pt 0pt 16pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:15pt; font-weight:normal; font-style:normal; text-decoration:none; color:#666666 }
			.Title { margin:0pt 0pt 3pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:26pt; font-weight:normal; font-style:normal; text-decoration:none; color:#000000 }
			span.DefaultParagraphFont { widows:0; orphans:0 }
		</style>
	</head>
	<body style="text-align: justify;">
			<h3 style="margin-top:14pt; page-break-inside:auto; page-break-after:auto; line-height:115%; font-size:13pt">
				<a id="h.ouodnux1xyov"></a><strong><span style="color:#000000">Política de Garantía de Mejor Precio con Descuento del 5%</span></strong>
			</h3>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>1. Descripción del Programa:</strong> La Política de Garantía de Mejor Precio con Descuento del 5% es ofrecida por Vacancy Rewards. Al presentar una reclamación o intentar aprovechar el Programa, usted acepta estos Términos y Condiciones.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>2. Elegibilidad:</strong> La política se aplica únicamente a socios activos que hayan realizado una reservación a<span> través de </span>nuestra plataforma en la sección "Hoteles" o para una Semana (aplicable únicamente para reservaciones de Semanas Smart o Semanas de Último Minuto).
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>3. Requisitos para la Igualación de Precio:</strong> Para calificar para el Programa, debe cumplir con los siguientes requisitos:
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tener una reservación pagada y confirmada utilizando su membresía Vacancy Rewards.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Proporcionar una prueba válida de una tarifa más baja encontrada para el mismo hotel, las mismas fechas, el mismo tipo de habitación, vista, condiciones de reserva (como políticas de cancelación) y cualquier beneficio adicional (como desayuno incluido).
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>La tarifa más baja debe ser accesible al público y estar disponible para reservar en el momento de la solicitud.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Las tarifas no disponibles al público, como tarifas corporativas, de membresía, de grupo, de paquete o cualquier tarifa que no sea accesible al público en general, no son elegibles.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>4. Proceso de Reclamo:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>El reclamo debe realizarse dentro de las 24 horas posteriores a la confirmación de la reserva original realizada a través de nuestro sitio web o confirmada por uno de nuestros agentes de reservaciones.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Debe enviar una solicitud por escrito a nuestro equipo de atención al cliente, incluyendo los detalles de la reserva original y la prueba de la tarifa más baja.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>La prueba deberá incluir una captura de pantalla y el enlace directo a la oferta del competidor, mostrando claramente todos los detalles requeridos.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>También puede realizar el reclamo por vía telefónica comunicándose con nuestro centro de atención.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>5. Validación del Reclamo:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Nuestro equipo de validación revisará la solicitud y la prueba proporcionada.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Se realizarán verificaciones para confirmar que la tarifa más baja cumple con todos los criterios de comparación.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>El proceso de validación puede tardar hasta dos días hábiles.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>6. Aquí están las cosas que verificaremos cuando procesemos su reclamación. La tarifa del sitio web no afiliado debe:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Estar en la misma moneda que la tarifa reservada a través de un canal de Vacancy Rewards.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Estar disponible para el público en general; en otras palabras, no debe requerir que se inscriba en ningún tipo de membresía o programa, ni iniciar sesión en un sitio web, para obtener la tarifa.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Estar disponible para reservar en el momento de la verificación.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Ser reservable solo si se proporciona una forma de pago para completar la reserva (¡las tarifas que no requieren una forma de pago no son elegibles!).
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Ser al menos un 1% más baja que la tarifa más baja disponible actualmente en el sitio web o la aplicación móvil de Vacancy Rewards, para tener en cuenta cualquier error de redondeo.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>La reservación deberá ser por lo menos de dos noches o más.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				El Programa se aplica solo a tarifas encontradas en sitios web no afiliados que cumplan con todos los criterios anteriores.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>7. Ejemplos de tarifas NO elegibles para el Programa incluye las siguientes:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas que no están disponibles para el público en general (como tarifas negociadas, tarifas para miembros o de lealtad, tarifas de grupo, tarifas corporativas).
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas que no son visibles o reservables por el público en general sin requisitos adicionales como residir en una geografía particular, usar un inicio de sesión con nombre de usuario/contraseña, usar una tarjeta de crédito específica, usar un código de descuento/cupón, o que requieran aprobación/verificación por correo electrónico o teléfono después de enviar el pago.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas en sitios web que no revelan la marca o el hotel hasta que se realiza la reserva.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas en sitios de subastas o que se reservan mediante un proceso similar.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas de paquetes que incluyen la habitación y otros componentes como transporte, alquiler de autos, entretenimiento y/o comidas no incluidas en el desayuno.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas en sitios web que permiten la reventa de reservas confirmadas.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Tarifas en sitios web que no proporcionan confirmación inmediata, que no resultan en una reserva de hotel real, o que no permiten hacer una reserva en tiempo real.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Reservas de una sola noche.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>8. Limitaciones y Reservas:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Nos reservamos el derecho de modificar o cancelar esta política en cualquier momento sin previo aviso.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Las decisiones sobre la elegibilidad de un reclamo son finales y a nuestra discreción.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Las comparaciones de precios se harán incluyendo impuestos, tarifas de servicio del hotel y otros cargos adicionales pagaderos al momento de hacer la reservación. Para reservas de más de una noche, la garantía se evaluará en función del precio total de la estancia.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Cualquier tarifa competidora más baja en una moneda diferente será convertida a la misma moneda de la tarifa ofrecida en nuestra plataforma, utilizando la tasa de cambio determinada por Vacancy Rewards.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>9. Ley Aplicable:</strong> Estos Términos y Condiciones y la oferta del Programa se regirán por las leyes del país en el que opera Vacancy Rewards, y la jurisdicción exclusiva para cualquier disputa no cubierta por este Acuerdo de Arbitraje será el tribunal competente en dicha jurisdicción.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>10. Acuerdo de Arbitraje:</strong> En la medida permitida por la ley aplicable, cualquier disputa que surja de estos Términos y Condiciones o de la oferta del Programa será sometida a arbitraje. Usted acepta estar sujeto a las siguientes disposiciones del Acuerdo de Uso de Vacancy Rewards: Limitación de Responsabilidad, Arbitraje, Período de Limitaciones y Renuncia a Reclamaciones Colectivas. Si el tribunal encuentra que la Renuncia a Reclamaciones Colectivas no es ejecutable, cualquier reclamación presentada en forma colectiva deberá ser presentada en un tribunal de jurisdicción competente.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				Al presentar un Formulario de Reclamación o aceptar los beneficios de una reclamación validada bajo el Programa, usted acepta liberar y exonerar a Vacancy Rewards y sus filiales de todas las reclamaciones o daños que surjan del uso o mal uso del Programa.
			</p>
	<p style="bottom: 10px; right: 10px; position: absolute;"><a href="https://wordtohtml.net" target="_blank" style="font-size:11px; color: #d0d0d0">Convertido a HTML con WordToHTML.net</a></p>
</body>
</html>`;

const PRICEMATCH_EN = `<!DOCTYPE html>
<html lang="en-US">
	<head>
<meta name="viewport" content="width=device-width, initial-scale=1.0">
		<meta charset="utf-8" />
		<title>
		</title>
		<style>
			body { line-height:115%; font-family:Arial; font-size:11pt }
			h1, h2, h3, h4, h5, h6, p { margin:0pt }
			li { margin-top:0pt; margin-bottom:0pt }
			h1 { margin:20pt 0pt 6pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:20pt; font-weight:normal; font-style:normal; text-decoration:none; color:#000000 }
			h2 { margin:18pt 0pt 6pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:16pt; font-weight:normal; font-style:normal; text-decoration:none; color:#000000 }
			h3 { margin:16pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:14pt; font-weight:normal; font-style:normal; text-decoration:none; color:#434343 }
			h4 { margin:14pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:12pt; font-weight:normal; font-style:normal; text-decoration:none; color:#666666 }
			h5 { margin:12pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:11pt; font-weight:normal; font-style:normal; text-decoration:none; color:#666666 }
			h6 { margin:12pt 0pt 4pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:11pt; font-weight:normal; font-style:italic; text-decoration:none; color:#666666 }
			.Subtitle { margin:0pt 0pt 16pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:15pt; font-weight:normal; font-style:normal; text-decoration:none; color:#666666 }
			.Title { margin:0pt 0pt 3pt; text-indent:0pt; text-align:left; page-break-inside:avoid; page-break-after:avoid; line-height:normal; widows:2; orphans:2; font-family:Arial; font-size:26pt; font-weight:normal; font-style:normal; text-decoration:none; color:#000000 }
			span.DefaultParagraphFont { widows:0; orphans:0 }
		</style>
	</head>
	<body>
			<h3 style="margin-top:14pt; page-break-inside:auto; page-break-after:auto; line-height:115%; font-size:13pt">
				<a id="h.g50uljdq5phw"></a><strong><span style="color:#000000">Best Price Guarantee Policy with 5% Discount</span></strong>
			</h3>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>1. Program Description:</strong> The Best Price Guarantee Policy with a 5% Discount is offered by Vacancy Rewards. By submitting a claim or attempting to take advantage of the Program, you agree to these Terms and Conditions.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>2. Eligibility:</strong> The policy applies only to active members who have made a reservation through our platform in the "Hotels" section or for a Week (applicable only to VIP Weeks or Last Minute Weeks reservations).
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>3. Requirements for Price Matching:</strong> To qualify for the Program, you must meet the following requirements:
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Have a paid and confirmed reservation using your Vacancy Rewards membership.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Provide valid proof of a lower rate found for the same hotel, the same dates, the same room type, view, reservation conditions (such as cancellation policies), and any additional benefits (such as included breakfast).
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>The lower rate must be publicly accessible and available to book at the time of the request.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates not available to the public, such as corporate, membership, group, package, or any rate not accessible to the general public, are not eligible.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>4. Claim Process:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>The claim must be made within 24 hours of the original reservation confirmation made through our website.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>You must submit a written request to our customer service team, including the details of the original reservation and proof of the lower rate.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>The proof must include a screenshot and a direct link to the competitor's offer, clearly showing all the required details.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Claims can also be made by phone by contacting our customer service center.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>5. Claim Validation:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Our validation team will review the submitted request and proof.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Verifications will be conducted to confirm that the lower rate meets all comparison criteria.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>The validation process may take up to two business days.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>6. Here are the things we’ll verify when we process your claim. The non-Vacancy Rewards website rate must:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Be in the same currency as the rate booked through a Vacancy Rewards channel.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Be available to the general public; in other words, you are not required to sign up for any kind of membership or program, or log in to a website, to obtain the rate.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Be available to book at the time of verification.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Be bookable only if you provide a form of payment to complete the booking (rates that do not require a form of payment are ineligible!).
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Be at least 1% lower than the current, lowest rate available on the Vacancy Rewards website or mobile app, to account for any rounding errors.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span><span>The reservation must be for at least two nights or more.</span>
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				The Program applies only to rates found on non-Vacancy Rewards websites that meet all of the above criteria.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>7. Examples of rates NOT eligible for the Program include the following:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates that are not available to the general public (such as negotiated rates, member or loyalty rates, group rates, corporate rates).
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates that are not visible or bookable by the general public without additional requirements such as residing in a particular geography, using a login with a username/password, using a specific credit card, using a discount code/coupon, or that require approval/verification via email or phone after payment is submitted.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates on websites that do not disclose the brand or hotel until the reservation is made.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates on auction websites or that are booked using a similar process.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Package rates that include the room and other components such as transportation, car rental, entertainment, and/or non-breakfast meals.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates on websites that allow confirmed reservations to be re-sold.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Rates on websites that do not provide immediate confirmation, that do not result in an actual hotel reservation, or that do not provide the ability to make a real-time reservation.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Single-night reservations.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>8. Limitations and Reservations:</strong>
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>We reserve the right to modify or cancel this policy at any time without prior notice.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Decisions regarding the eligibility of a claim are final and at our discretion.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Price comparisons will be made including taxes, hotel service fees, and other additional charges payable at the time of booking. For reservations of more than one night, the guarantee will be evaluated based on the total price of the stay.
			</p>
			<p style="margin-left:54pt; text-indent:-18pt">
				<span>●</span><span style="width:11.36pt; font:7pt 'Times New Roman'; display:inline-block">&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0;&#xa0; </span>Any lower competing rate in a different currency will be converted to the same currency as the rate offered on our platform, using the exchange rate determined by Vacancy Rewards.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>9. Governing Law:</strong> These Terms and Conditions and the offer of the Program will be governed by the laws of the country in which Vacancy Rewards operates, and the exclusive jurisdiction for any dispute not covered by this Arbitration Agreement will be the competent court in such jurisdiction.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				<strong>10. Arbitration Agreement:</strong> To the extent permitted by applicable law, any disputes arising from these Terms and Conditions or the offer of the Program will be submitted to arbitration. You agree to be bound by the following provisions of the Vacancy Rewards Terms of Use: Limitation of Liability, Arbitration, Limitations Period, and Waiver of Class Claims. If the court finds the Waiver of Class Claims unenforceable, any claim filed on a class basis must be filed in a court of competent jurisdiction.
			</p>
			<p style="margin-top:12pt; margin-bottom:12pt">
				By submitting a Claim Form or accepting the benefits of a validated claim under the Program, you agree to release and hold harmless Vacancy Rewards and its affiliates from all claims or damages arising from the use or misuse of the Program.
			</p>
	<p style="bottom: 10px; right: 10px; position: absolute;"><a href="https://wordtohtml.net" target="_blank" style="font-size:11px; color: #d0d0d0">Convertido a HTML con WordToHTML.net</a></p>
</body>
</html>`;

const TERMS_ES = `<h3 id="-t-rminos-y-condiciones-"><strong>TÉRMINOS Y CONDICIONES</strong></h3><p>(Última Actualización: 29 de enero de 2025)</p><p>Bienvenido a Vacancy Rewards. Al utilizar nuestros servicios, aceptas estos Términos y Condiciones, que rigen tu acceso y uso de nuestro sitio web, servicios de membresía y productos de viaje. Por favor, lee estos términos cuidadosamente y contáctanos si tienes alguna pregunta.</p><p>Nuestro sitio web te ayuda a explorar y descubrir opciones de viaje, verificar disponibilidad y realizar reservaciones de semanas en resorts, hospedaje en hoteles, vuelos, alquiler de autos y otros servicios de viaje proporcionados por proveedores externos. Los servicios incluyen semanas en resorts, hoteles, boletos de avión, alquiler de autos, boletos para atracciones, paseos en ferry, boletos de autobús, tours y cruceros. Al reservar a través de cualquier sitio web operado por Vacancy Rewards, aceptas los términos tanto de nuestro sitio como del proveedor correspondiente.</p><p>Los términos del proveedor son fundamentales, ya que constituyen un acuerdo legal independiente entre tú y el proveedor. En caso de cualquier discrepancia entre los términos del proveedor y los nuestros, prevalecerán nuestros términos. Asegúrate de revisarlos detenidamente durante el proceso de reserva, ya que pueden incluir disposiciones importantes sobre cancelaciones, cambios y otras condiciones.</p><p>Además, estos términos rigen tu uso del sitio web de Vacancy Rewards, incluidas las reglas para realizar y pagar reservaciones, así como cualquier otra interacción con nuestro sitio. Al utilizar nuestro sitio web y completar una reserva, aceptas estar sujeto a estos términos. Recomendamos imprimir o guardar una copia para referencia futura.</p><p>Debes ser mayor de edad y tener la capacidad legal para formar un contrato vinculante. Aceptas usar nuestro sitio web solo con fines legítimos.</p><p>En el caso de múltiples reservaciones, la persona que realiza la reserva es responsable de proporcionar información precisa sobre todos los participantes, aceptar estos términos en su nombre, verificar los detalles de la reserva y pagar la totalidad de la misma.</p><p>Podemos modificar estos términos sin previo aviso. Por favor, revísalos periódicamente para actualizaciones en la parte inferior de esta página.</p><p><strong>A) PROCESO DE REGISTRO - TU</strong> CUENTA<strong>:</strong> Como usuario registrado de los servicios de Vacancy Rewards, creamos una cuenta (\u201CCuenta\u201D) al momento de la compra. Sugerimos que nunca compartas tu información de cuenta con terceros. Eres el único responsable de mantener la confidencialidad y seguridad de tu cuenta y de todas las actividades que ocurran en ella o a través de ella. También aceptas notificar inmediatamente a Vacancy Rewards sobre cualquier fallo en la seguridad de tu cuenta. Vacancy Rewards no será responsable por pérdidas derivadas de accesos no autorizados o uso indebido de tu cuenta.</p><p><strong>B) Exactitud de la Información:</strong> Como usuario registrado, aceptas proporcionar información precisa y completa al registrarte y al usar los productos y servicios de Vacancy Rewards. También te comprometes a actualizar tu información de registro para mantenerla correcta y completa. Aceptas que Vacancy Rewards almacene y use la información proporcionada para mantener y facturar tu cuenta. Toda la información estará sujeta a nuestra política de privacidad.</p><p><strong>C) Transacciones Electrónicas:</strong> El uso de los productos y servicios de Vacancy Rewards incluye la capacidad de realizar transacciones electrónicamente. RECONOCES QUE LAS SOLICITUDES ELECTRÓNICAS CONSTITUYEN TU ACEPTACIÓN E INTENCIÓN DE ESTAR OBLIGADO A PAGAR POR DICHAS RESERVACIONES Y TRANSACCIONES. TU ACEPTACIÓN SE APLICA A TODOS LOS REGISTROS RELACIONADOS CON TODAS LAS TRANSACCIONES REALIZADAS EN LA PÁGINA WEB, LA AGENCIA DE VIAJES EN LÍNEA O CUALQUIER OTRO MEDIO ELECTRÓNICO OFRECIDO POR LA COMPAÑÍA, INCLUYENDO AVISOS DE CANCELACIÓN, POLÍTICAS Y PROCEDIMIENTOS.</p><h3 id="-reglas-para-el-uso-del-sitio-web-de-vacancy-rewards-"><strong>Reglas para el Uso del Sitio Web de Vacancy Rewards</strong></h3><ol><li><strong>Podemos Realizar Cambios en el Sitio Web</strong><br>Podemos actualizar o modificar el sitio web periódicamente para introducir nuevos servicios, mejorar la experiencia del usuario o alinearnos con prioridades comerciales. Haremos un esfuerzo por notificarte sobre cambios significativos.  </li><li><strong>Disponibilidad del Sitio Web</strong><br>Aunque nos esforzamos por ofrecer acceso ininterrumpido al sitio web de Vacancy Rewards, no podemos garantizar que siempre estará disponible. El acceso puede suspenderse temporalmente por mantenimiento u otras razones operativas. No somos responsables de las interrupciones causadas por factores fuera de nuestro control, como fallos de Internet, problemas del sistema o malware.<br>Eres responsable de contar con la tecnología necesaria (como una conexión a Internet y un dispositivo) para acceder al sitio web de Vacancy Rewards, y de asegurarte de que cualquier persona que acceda al sitio a través de tu conexión esté al tanto de estos términos.  </li><li><strong>Detalles de la Cuenta</strong><br>Eres responsable de proporcionar información de cuenta precisa y completa, y de mantener tus credenciales de inicio de sesión seguras y confidenciales. Además, te recomendamos que nos notifiques de inmediato si sospechas de accesos no autorizados. Si tu cuenta es comprometida debido a actividades no autorizadas o sospechosas, contáctanos y avisa a tu banco o compañía de tarjeta de crédito para limitar posibles pérdidas. Nos reservamos el derecho de suspender o desactivar tu cuenta si no cumples con estos términos y condiciones o si detectamos actividad sospechosa.  </li><li><strong>Propiedad Intelectual</strong><br>Vacancy Rewards es propietario o tiene licencia de todo el contenido del sitio web. Solo puedes descargar o imprimir materiales para uso personal y no debes utilizar ni modificar ninguna parte del contenido con fines comerciales sin previa autorización. Cualquier incumplimiento de estos términos y condiciones sobre la propiedad intelectual resultará en la terminación de tu derecho a usar el sitio web de Vacancy Rewards.  </li><li><strong>Enlaces a Sitios Web de Terceros</strong><br>El sitio web de Vacancy Rewards puede incluir enlaces a sitios web y recursos de terceros para tu conveniencia. No somos responsables del contenido o la disponibilidad de estos sitios, y la inclusión de enlaces no implica respaldo alguno.  </li><li><strong>Suscripción Anual</strong><br>Para mantener el acceso a la plataforma de Vacancy Rewards y conservar todos los beneficios de la membresía, tu cuenta debe estar activa y en buen estado. La cuota de suscripción anual debe pagarse en su totalidad en o antes de la fecha de aniversario de tu membresía. Las cuotas de suscripción están sujetas a cambios y serán comunicadas antes de tu renovación. El incumplimiento del pago de la cuota anual en la fecha de vencimiento resultará en la suspensión del acceso a la plataforma y sus beneficios asociados hasta que se reciba el pago y se actualice la cuenta.  </li><li><strong>Usos Prohibidos</strong><br>Aceptas utilizar el sitio web de Vacancy Rewards únicamente con fines legales. Las siguientes actividades están prohibidas:  <ul><li>Participar en comportamientos ilegales, fraudulentos o abusivos.  </li><li>Realizar actividades que violen cualquier ley o regulación local, nacional o internacional aplicable.  </li><li>Llevar a cabo acciones que dañen o intenten dañar a menores de cualquier forma.  </li><li>Subir o compartir material que contenga códigos maliciosos, como virus o malware.  </li><li>Intentar acceder de manera no autorizada a cualquier parte del sitio web de Vacancy Rewards o sistemas relacionados.  </li><li>Interferir con el funcionamiento adecuado del sitio web o introducir una carga de datos irrazonable.</li></ul></li></ol><p>Las violaciones de estas reglas pueden resultar en la terminación de tu acceso al sitio web.</p><h3 id="-t-rminos-generales-de-reservas-aplicables-a-todos-los-productos-de-viaje-"><strong>Términos Generales de Reservas (aplicables a todos los productos de viaje)</strong></h3><p><strong>a) Precios y Detalles:</strong><br>Asegúrate de que toda la información proporcionada durante el proceso de reserva, como tu nombre, detalles de identificación, información de contacto, datos de pago y fechas, sea precisa y completa. Si detectas que algún dato proporcionado es incorrecto, te asistiremos para intentar actualizar la reserva. Sin embargo, no podemos garantizar que el proveedor permita realizar cambios, especialmente si implican un cambio de identidad.<br>Promovemos y mostramos una amplia gama de productos de viaje y hacemos todo lo posible por garantizar que los precios publicados sean siempre correctos. No obstante, pueden ocurrir errores. Si el error es razonablemente evidente, nos reservamos el derecho de cancelar la reserva o, si estás de acuerdo, ajustar el precio. Si esto sucede, nos pondremos en contacto contigo.</p><p><strong>b) Proceso de Reserva:</strong><br>Te enviaremos un correo electrónico de confirmación una vez que tu reserva esté completa. Aceptas revisar los detalles de la confirmación y notificarnos de inmediato si detectas algún error. Más información sobre confirmaciones de vuelos y hoteles se encuentra en las secciones correspondientes.<br>Asignaremos un número de confirmación de Vacancy Rewards a tu reserva. Este número será útil para agilizar cualquier consulta relacionada con tu reserva cuando nos contactes.</p><p><strong>Prohibiciones al Usar los Servicios de Reservas de Vacancy Rewards:</strong></p><ul><li>No utilices una tarjeta bancaria o cuenta que no estés autorizado a usar.  </li><li>No finjas ser otra persona ni representes de manera falsa tu identidad o conexión con otra persona.  </li><li>No violes ninguna ley, reglamento o requerimiento regulatorio.</li></ul><p><strong>Disponibilidad de los Productos de Viaje:</strong><br>Todas las reservas de productos de viaje están sujetas a disponibilidad al momento de realizar la reserva. Aunque hacemos un esfuerzo por mantener nuestro sitio actualizado, no podemos garantizar la disponibilidad de los productos. Te notificaremos si el producto de viaje que solicitaste no está disponible después de realizar tu reserva.</p><p>Es posible que necesitemos información adicional para validar tu reserva. Si no proporcionas la información solicitada o si determinamos que es insuficiente, tu solicitud de reserva será cancelada. Ten en cuenta que un producto puede dejar de estar disponible, y no seremos responsables por ninguna pérdida o costo asociado en tales circunstancias.</p><h3 id="-pagos-y-moneda-"><strong>Pagos y Moneda</strong></h3><p><strong>Métodos de Pago Aceptados:</strong><br>Vacancy Rewards acepta pagos únicamente a través de Visa, MasterCard, Discover y Diners Club. No se aceptan pagos mediante PayPal, pagos en efectivo, transferencias de dinero ni tarjetas de regalo depositadas en cuentas personales bajo ninguna circunstancia.</p><p><strong>Contacto Autorizado:</strong><br>Solo los siguientes departamentos de Vacancy Rewards están autorizados para contactarte con respecto a pagos: Servicio al Cliente, Reservaciones, Soporte Web y Cobranza de Cuotas Anuales.</p><p><strong>Términos de Pago para Reservas:</strong><br>Los términos de pago para las reservas de viaje se detallarán claramente durante el proceso de reserva. Algunas reservas pueden requerir pago completo en línea, mientras que otras pueden permitir el pago al momento del uso.</p><p><strong>Falta de Pago:</strong><br>El incumplimiento en el pago del monto requerido en su totalidad puede resultar en la cancelación inmediata de la reserva. Las reservas también pueden ser canceladas si detectamos actividad sospechosa del usuario o si los métodos de pago indican signos de fraude o son considerados inválidos por cualquier motivo.</p><p><strong>Moneda y Precios:</strong><br>Todos los precios mostrados en el sitio web de Vacancy Rewards están en dólares estadounidenses (USD). Si eliges pagar por adelantado en línea, tu cuenta será cargada en USD, y cualquier tasa de cambio de divisas o cargo adicional dependerá de tu institución financiera.</p><h3 id="-preparativos-de-viaje-"><strong>Preparativos de Viaje</strong></h3><ul><li><strong>Documentos de Viaje:</strong> Debes asegurarte de contar con el seguro adecuado y los documentos de viaje necesarios para tu viaje. Esto incluye, entre otros, tu pasaporte, identificación nacional, visas y documentos médicos (como prueba de vacunación).  </li><li><strong>Advertencias de Viaje:</strong> Cuando ofrecemos productos de viaje para un destino específico, no garantizamos ni confirmamos que sea seguro viajar a dicho destino. Es tu responsabilidad verificar cualquier advertencia o restricción de viaje en el destino antes de reservar y viajar.  </li><li><strong>Vacunaciones y Salud:</strong> Es tu responsabilidad obtener las vacunas necesarias para tu viaje y seguir cualquier consejo médico que hayas recibido.</li></ul><h3 id="-beneficios-para-usuarios-de-vacancy-rewards-"><strong>Beneficios para Usuarios de Vacancy Rewards</strong></h3><p><strong>a) Hoteles</strong><br>Acceso a más de 1 millón de hoteles con tarifas exclusivas para miembros, ofreciendo descuentos de hasta un 60% sobre los precios públicos.</p><p><strong>b) Rentas Vacacionales Semanales</strong><br>Miles de alojamientos estilo resort para múltiples huéspedes, con 7 noches consecutivas en condominios totalmente equipados disponibles en más de 75 países.</p><p><strong>c) Garantía del Mejor Precio</strong><br>Si encuentras una mejor oferta para el mismo hotel o condominio dentro de las 48 horas posteriores a tu reserva, igualaremos y superaremos el precio en un 5%.</p><p><strong>d) Tarifas Exclusivas de Cruceros</strong><br>Acceso a más de 25,000 itinerarios de cruceros para explorar los siete mares.</p><p><strong>e) Tours y Actividades</strong><br>Más de 350,000 tours y actividades en todo el mundo con tarifas exclusivas no disponibles para el público general.</p><p><strong>f) Alquiler de Autos</strong><br>Acceso a tarifas con descuento de cientos de compañías de alquiler de autos con más de 10,000 ubicaciones de recogida.</p><p><strong>g) Acceso a Más de 200 Aerolíneas</strong><br>Expertos en encontrar los vuelos más económicos en las mejores aerolíneas, incluidas aerolíneas de bajo costo.</p><p><strong>h) Paquetes de Viaje</strong><br>Planificación de viajes sin complicaciones con paquetes que incluyen vuelos y alojamiento a precios competitivos.</p><p><strong>i) Paquetes Multidestino</strong><br>Aventuras inolvidables con paquetes todo incluido que incluyen vuelos, estancias en hoteles, actividades y traslados entre destinos.</p><h3 id="-reservas-de-hoteles-"><strong>Reservas de Hoteles</strong></h3><p>Tu reserva de hotel también está sujeta a los términos y condiciones del hotel, los cuales generalmente se encuentran en el sitio web del hotel. Estos términos se aplicarán en caso de discrepancias (como la selección de una habitación no reembolsable). Si tienes preguntas o inquietudes, puedes comunicarte con el departamento de servicio al cliente.</p><p><strong>Proceso de Reserva:</strong><br>Nos esforzamos por confirmar tu reserva de hotel dentro del período de tiempo indicado durante el proceso de reserva. Si la confirmación se retrasa, por favor contáctanos. La mayoría de las reservas de habitaciones se confirman de inmediato, y tu habitación está garantizada una vez que se confirma. Recibirás un reembolso completo si no podemos confirmar tu reserva.</p><p>Si contactas al hotel y no encuentran tu reserva, no te preocupes: tu reserva sigue siendo válida. Los hoteles pueden no recibir tus datos personales hasta que la fecha de reserva esté más próxima.</p><p><strong>Modificación, Cancelación o Actualización de Tu Reserva de Hotel:</strong><br>Durante el proceso de reserva, te proporcionamos información sobre tus derechos para cambiar o cancelar tu reserva de hotel. Algunas habitaciones con precios más bajos pueden no ser elegibles para cambios o reembolsos. Si tienes dudas sobre los términos, no dudes en contactar al departamento de servicio al cliente.</p><p>Cuando se permitan cambios, el hotel o el proveedor de inventario pueden limitar las opciones de habitaciones disponibles. Te informaremos de las opciones disponibles al recibir tu solicitud. Si el hotel cancela o modifica tu reserva, se aplicarán sus términos, y te asistiremos a través de nuestro departamento de servicio al cliente.</p><p><strong>Calificaciones de los Hoteles:</strong><br>Nuestras calificaciones de huéspedes se basan en reseñas verificadas de los usuarios. Las calificaciones por estrellas se determinan combinando información, como las calificaciones proporcionadas directamente por los hoteles (incluyendo, cuando corresponda, su clasificación por estándares del país), servicios, fotos, reseñas de huéspedes y precios. Esto tiene como objetivo proporcionarte la mejor indicación del estándar del hotel.</p><p>Sin embargo, reconoces y aceptas que la calificación por estrellas es solo una indicación. Los estándares varían entre países, y es tu responsabilidad revisar toda la información proporcionada sobre el hotel en nuestro sitio web para asegurarte de que estás conforme con el estándar del hotel antes de reservar.</p><h3 id="-reservas-de-semanas-en-resorts-"><strong>Reservas de Semanas en Resorts</strong></h3><p>En Vacancy Rewards, ofrecemos la mayor selección de alojamientos estilo resort para múltiples huéspedes y familias. Los huéspedes pueden hospedarse siete noches consecutivas en hermosas unidades tipo condominio, desde estudios hasta unidades de tres habitaciones, en múltiples ubicaciones alrededor del mundo. Nuestras semanas en resorts están respaldadas por las compañías de cumplimiento más antiguas y respetadas de la industria.</p><p>Con un portafolio diario de más de <strong>150,000+ semanas de resort disponibles</strong>, que cubren más de 70 países en todos los continentes, tenemos todo lo que buscan nuestros clientes. Los precios publicados representan el monto total por toda la semana, generalmente equivalente o menor al costo de mantenimiento.</p><p><strong>Tipos de Semanas Disponibles:</strong></p><ul><li><strong>Last-Minute Weeks:</strong> Disponibles entre 3 y 30 días antes del check-in.  </li><li><strong>Smart Weeks:</strong> Desde estudios hasta unidades de tres habitaciones, disponibles con hasta 6 meses de anticipación.  </li><li><strong>VIP Weeks:</strong> Disponibilidad en tiempo real que permite reservar con hasta un año de anticipación.</li></ul><p><strong>Costo y Disponibilidad:</strong><br>El costo y la disponibilidad de las semanas ofrecidas pueden variar según factores como la oferta y la demanda. Estos factores incluyen la inflación, la calidad de la propiedad, el tamaño de la unidad, el destino y las tendencias estacionales. Si bien nos esforzamos por ofrecer las mejores opciones, los precios y la disponibilidad están sujetos a cambios basados en estas consideraciones.</p><p><strong>Modificación o Cancelación de Tu Reserva:</strong><br>Una vez que se confirma y paga una reserva de semanas en resorts, se considera final. Ten en cuenta que no se pueden realizar cambios, cancelaciones ni reembolsos. Recomendamos a los miembros revisar cuidadosamente sus planes antes de completar su reserva.</p><p><strong>Nota:</strong><br>Los precios mostrados en el sitio web para semanas en resorts solo incluyen el alojamiento y no contemplan cargos adicionales aplicables, como planes todo incluido, transporte, recargos por habitación, impuestos locales u otros cargos adicionales. Los miembros son responsables de cubrir estos cargos directamente con el resort o los proveedores de servicios relevantes.</p><h3 id="-t-rminos-de-vuelos-"><strong>Términos de Vuelos</strong></h3><p><strong>Términos y Condiciones de las Aerolíneas:</strong><br>Todas las reservas de boletos de avión deben realizarse y confirmarse en línea por el miembro o una persona autorizada para hacer la reserva. Debido a la amplia variedad de opciones e itinerarios disponibles, los agentes de Vacancy Rewards no están autorizados a realizar la reserva para evitar errores humanos en la selección de aerolíneas o itinerarios.</p><p><strong>Nota:</strong> Tu reserva está sujeta a los términos y condiciones de la aerolínea, que generalmente están disponibles en el sitio web de la misma. En caso de contradicciones entre estos términos y los términos y condiciones de la aerolínea, prevalecerán los términos aquí establecidos. Si tienes preguntas sobre los términos asociados con tu boleto de avión (como reglas de cambios, cancelaciones o equipaje), contacta directamente a la aerolínea. También puedes comunicarte con nuestro servicio de atención al cliente, y haremos lo posible por asistirte.</p><h3 id="-proceso-de-reserva-"><strong>Proceso de Reserva</strong></h3><ul><li>Después de confirmar tu pago en línea, recibirás un correo electrónico con los detalles de tu reserva. Por favor, revisa cuidadosamente el correo y avísanos de inmediato si detectas algún error.  </li><li>Haremos todo lo posible por emitir tu boleto de avión dentro del plazo especificado durante tu proceso de reserva. Si no has recibido tu boleto dentro de este plazo, contacta a nuestro servicio de atención al cliente.  </li><li>Una vez emitido tu boleto, recibirás un correo electrónico titulado <strong>Confirmación de Reserva de Vuelo</strong>, que incluirá tu itinerario y un recibo electrónico.  </li><li>Si seleccionaste un boleto económico, la emisión del boleto podría demorar más, pero será emitido a más tardar 72 horas antes de tu vuelo.  </li><li>Para vuelos reservados dentro de los tres días previos a la salida, los boletos se emitirán dentro de las 72 horas previas a la salida.  </li><li>Cuando hagas el check-in para tu vuelo, tu boleto será emitido como un boleto electrónico (e-ticket).</li></ul><p>Se te asignará un número de reserva de Vacancy Rewards, que recibirás por correo electrónico. Por favor, proporciona este número al contactarnos sobre tu reserva. También recibirás el número de referencia de la aerolínea o un identificador similar. Si este no aparece en tu correo de confirmación, contacta a nuestro servicio al cliente.</p><h3 id="-modificaci-n-o-cancelaci-n-de-tu-reserva-"><strong>Modificación o Cancelación de Tu Reserva</strong></h3><p>Durante el proceso de reserva, se te proporcionará información sobre tus derechos para modificar o cancelar tu vuelo, así como cualquier cargo asociado. Es posible que hayas seleccionado un boleto de menor costo, que no sea reembolsable ni modificable. Esta información forma parte de nuestros términos, así que revísala cuidadosamente antes de finalizar tu reserva. La misma información estará disponible en el enlace del correo de confirmación de tu vuelo o accediendo a tu reserva a través de nuestro sitio web.</p><ul><li><strong>Si los cambios están permitidos:</strong> Puedes solicitarlos iniciando sesión en tu cuenta en nuestro sitio web o contactándonos directamente. Los no miembros pueden acceder a la reserva y solicitar modificaciones ingresando el correo electrónico utilizado durante la reserva.  </li><li><strong>Opciones limitadas:</strong> Cuando se permiten cambios, las opciones disponibles pueden ser limitadas por la aerolínea o el proveedor de boletos. Te informaremos de las opciones disponibles al recibir tu solicitud.  </li><li><strong>Si la aerolínea cancela o modifica tu vuelo:</strong> Se aplicarán los términos y condiciones de la aerolínea. Contáctanos, y te asistiremos a través de nuestro servicio al cliente.</li></ul><h3 id="-detalles-importantes-del-vuelo-"><strong>Detalles Importantes del Vuelo</strong></h3><p>Cuando sea posible, proporcionaremos información como:</p><ul><li>Horarios de check-in y embarque.  </li><li>Selección de asientos.  </li><li>Restricciones y límites de equipaje.  </li><li>Disponibilidad de boletos para infantes/niños.</li></ul><p>Siempre verifica esta información en el sitio web de la aerolínea.</p><p>Para información específica sobre requisitos de pasajeros (por ejemplo, viajeros mayores, embarazadas o infantes), regulaciones sobre baterías de litio, materiales peligrosos o líquidos, o solicitudes de servicios/comidas especiales, consulta el sitio web de la aerolínea. Si deseas solicitar servicios especiales o comidas a través de nosotros, contáctanos según lo indicado en la Sección 1.</p><h3 id="-responsabilidad-del-pasajero-"><strong>Responsabilidad del Pasajero</strong></h3><p>Es tu responsabilidad llegar con tiempo suficiente para completar el check-in, el control de pasaportes y la seguridad en el aeropuerto. Asegúrate de llevar todos los documentos necesarios para viajar, como pasaportes, visas e identificaciones nacionales.</p><p><strong>Importante:</strong> Los boletos de avión deben usarse en el orden especificado en tu itinerario. Si omites un vuelo (por ejemplo, el vuelo de ida), la aerolínea puede cancelar la porción restante de tu reserva. Verifica la política específica de la aerolínea.</p><h3 id="-t-rminos-de-viajes-en-tren-"><strong>Términos de Viajes en Tren</strong></h3><p><strong>Términos y Condiciones del Operador de Tren:</strong><br>Tu boleto de tren está sujeto a los términos y condiciones del operador ferroviario, los cuales se presentaron durante el proceso de reserva.</p><p><strong>Modificación o Cancelación de tu Boleto de Tren:</strong><br>Revisa los términos del operador ferroviario para obtener detalles sobre cambios o cancelaciones de boletos. Si el operador modifica o cancela tu reserva, se aplicarán sus términos. También puedes contactarnos para recibir asistencia.</p><h3 id="-tours-y-otros-servicios-otros-productos-en-nuestro-sitio-web-como-traslados-al-aeropuerto-boletos-para-atracciones-alquiler-de-autos-etc-"><strong>Tours y Otros Servicios (otros productos en nuestro sitio web, como traslados al aeropuerto, boletos para atracciones, alquiler de autos, etc.)</strong></h3><p><strong>Términos y Condiciones del Proveedor:</strong><br>Todas las reservas para servicios como alquiler de autos, traslados al aeropuerto o boletos para atracciones están sujetas a los términos del proveedor, los cuales generalmente están disponibles en su sitio web. Si el proveedor modifica o cancela tu reserva, se aplicarán sus términos, y estaremos disponibles para asistirte.</p><h3 id="-responsabilidad-"><strong>Responsabilidad</strong></h3><p><strong>Nuestra Responsabilidad por Pérdidas o Daños:</strong><br>Nos esforzamos por proporcionar información precisa y actualizada en el sitio web de Vacancy Rewards. Sin embargo, no podemos garantizar la disponibilidad, precisión o integridad de la información, productos o servicios ofrecidos por proveedores externos.</p><p>No hacemos representaciones, garantías ni promesas sobre la información en nuestro sitio web. Cualquier garantía implícita, condición o representación queda excluida, excepto las que están prohibidas por ley.</p><p>No somos responsables por daños o pérdidas resultantes del uso del sitio web de Vacancy Rewards, incluidas interrupciones de viaje, cancelaciones o pérdidas personales. El uso del sitio y la confianza en cualquier información es bajo tu propio riesgo.</p><p><strong>En la medida permitida por la ley, no somos responsables de pérdidas o daños resultantes de:</strong></p><ul><li>Información incorrecta proporcionada al realizar una reserva (nombre, datos de identificación, detalles de contacto, información de pago, fechas u horarios).  </li><li>Fallos al contactarte debido a información de contacto incorrecta.  </li><li>Incapacidad para utilizar un producto de viaje (como abordar un avión, registrarte en un hotel o alquilar un auto) porque los datos no coinciden con tus documentos.  </li><li>No contar con documentación adecuada (pasaportes, visas, comprobantes de vacunación, etc.).  </li><li>Falta de seguro de viaje apropiado.  </li><li>Incumplimiento de los términos y condiciones del proveedor, como no llegar a tiempo o no cumplir con procedimientos de check-in o estándares de comportamiento.  </li><li>Conexiones perdidas de vuelos, trenes, autobuses o ferries debido a tus acciones u omisiones.  </li><li>Uso de tarjetas de descuento inválidas (por ejemplo, tarjetas de tren).  </li><li>Errores en la reserva, incluidas reservas duplicadas.  </li><li>Cargos bancarios, cambios en tasas de cambio o comisiones por transacciones internacionales.  </li><li>Comunicación directa con proveedores fuera de nuestra plataforma.  </li><li>Información desactualizada, falsa o incompleta proporcionada por ti.  </li><li>Viajar a áreas con restricciones o advertencias.  </li><li>Eventos fuera de nuestro control, incluidos:  <ul><li>Desastres naturales, pandemias o epidemias.  </li><li>Actos de terrorismo, guerras o disturbios civiles.  </li><li>Acciones gubernamentales, sanciones o cambios en la legislación.  </li><li>Fallos del sistema o Internet, virus o ciberataques.</li></ul></li></ul><p><strong>Nota:</strong> Nuestro sitio web está destinado para uso personal únicamente. Al usar nuestros servicios, aceptas no utilizar el sitio para fines comerciales. No somos responsables de pérdidas de beneficios, negocios u oportunidades resultantes del uso del sitio.</p><h3 id="-incumplimiento-de-estos-t-rminos-por-parte-del-usuario-"><strong>Incumplimiento de Estos Términos por Parte del Usuario</strong></h3><p>El incumplimiento de estos términos o de leyes aplicables puede resultar en acciones que tomemos a nuestra discreción, incluyendo:</p><ul><li>Cancelación de reservas asociadas a tu nombre, correo electrónico o cuenta.  </li><li>Revocación de recompensas, incentivos o beneficios obtenidos.  </li><li>Restricción o eliminación permanente de tu acceso a nuestro sitio web o servicios de reserva.  </li><li>Eliminación de cualquier contenido que hayas subido.  </li><li>Emisión de advertencias o inicio de procedimientos legales para el reembolso de costos (incluidos costos administrativos y legales).  </li><li>Divulgación de información a las autoridades legales según sea requerido.  </li><li>Otras medidas que consideremos apropiadas.</li></ul><p>Si tu reserva se cancela debido a un incumplimiento de estos términos, es posible que no tengas derecho a un reembolso. Los reembolsos solo se considerarán si proporcionas evidencia de que la cancelación se realizó por error.</p><h3 id="-quejas-"><strong>Quejas</strong></h3><p>Si tienes preguntas o quejas sobre nuestro sitio web o servicios, utiliza los detalles proporcionados en la Sección 1 de estos términos para contactarnos.</p><h3 id="-ley-aplicable-y-jurisdicci-n-"><strong>Ley Aplicable y Jurisdicción</strong></h3><p>Estos términos se rigen por las leyes del estado de Florida. Las disputas estarán sujetas a la jurisdicción de los tribunales de Florida, a menos que los derechos del consumidor en tu país de residencia dispongan lo contrario.</p><h3 id="-idioma-"><strong>Idioma</strong></h3><p>En caso de inconsistencias entre la versión en inglés de estos términos y las traducciones, prevalecerá la versión en inglés.</p><h3 id="-otros-"><strong>Otros</strong></h3><p>Estos términos son únicamente entre tú y nosotros. Ninguna otra parte tiene derecho a hacerlos cumplir. Si alguna disposición se considera inválida, las disposiciones restantes seguirán siendo aplicables. Los retrasos en la aplicación de los términos no renuncian a nuestro derecho de actuar posteriormente.</p><p>Estos términos detallan tus responsabilidades legales al usar el sitio web de Vacancy Rewards y reservar servicios de viaje. Si tienes preguntas, contáctanos en <strong>support@vacancyrewards.com</strong>.</p>`;
const TERMS_EN = `<h3><strong>TERMS AND CONDITIONS</strong></h3><p><strong>(Last Update: January 29, 2025)</strong> </p><p>Welcome to Vacancy Rewards. By using our services, you agree to these Terms and Conditions, which govern your access to and use of our website, membership services, and travel products. Please read these terms carefully and contact us if you have any questions.</p><p>Our website helps you explore and discover travel options, check availability, and make reservations for resort weeks, hotel accommodations, flights, rental cars, and other travel services provided by third-party suppliers. Services include resort weeks, hotels, airline tickets, car rentals, attraction tickets, ferry rides, bus tickets, tours, and cruises. By booking through any website powered by Vacancy Rewards, you agree to the terms of both our site and the relevant supplier.</p><p>Supplier terms are crucial as they constitute a separate legal agreement between you and the Supplier. In the event of any inconsistency between the Supplier&#39;s terms and our terms, our terms will prevail. Make sure to review them carefully during the booking process, as they may contain important provisions regarding the cancellation, changes, and other conditions.</p><p>Additionally, these terms govern your use of the Vacancy Rewards website, including the rules for making and paying for reservations and any other form of interaction with the Vacancy Rewards website. By using our website and completing a booking, you agree to be bound by these terms. We recommend printing or saving a copy for future reference.</p><p>You must be of legal age and have the capacity to form a legally binding contract. You agree to use our website for legitimate purposes only.</p><p>For multiple bookings, the person making the reservation is responsible for providing accurate information about all participants, accepting these terms on their behalf, verifying the booking details, and paying for the entire reservation.</p><p>We may modify these terms without notice. Please review them periodically for updates at the bottom of this page.</p><p><strong>A) Registration process - your account</strong>: As a registered user of the services of Vacancy Rewards, we have created an account (&quot;Account&quot;) at the time of purchase. We suggest that you never disclose your Account information to any third party. You are solely responsible for maintaining the confidentiality and security of your Account and for all activities that occur on or through your Account. You also agree to immediately notify Vacancy Rewards of any failure to secure your account. Vacancy Rewards will not be liable for any loss arising from any unauthorized access to or use of your Account.</p><p><strong>B) Accuracy of information</strong>: As a registered user, you agree to provide accurate and complete information when registering and when using the Products and Services of Vacancy Rewards, as well as to update your registration information to keep such information accurate and complete. You agree that Vacancy Rewards will store and use the registration information supplied to maintain and bill your account. Any registration information will be subject to the provisions of the privacy policy of Vacancy Rewards.</p><p><strong>C) Electronic Transaction</strong>: The use of the Products and Services of Vacancy Rewards includes the ability to make transactions electronically. YOU ACKNOWLEDGE THAT ELECTRONIC REQUESTS CONSTITUTE YOUR ACCEPTANCE AND INTENTION TO BE BOUND BY AND PAY FOR SUCH RESERVATIONS AND TRANSACTIONS. YOU&#39;RE ACCEPTANCE AND INTENTION TO ABIDE BY THOSE ELECTRONIC REQUESTS APPLY TO ALL RECORDS RELATING TO ALL TRANSACTIONS THAT ARE PERFORMED ON THE WEB PAGE, AT THE ONLINE TRAVEL AGENCY, OR ANY OTHER ELECTRONIC MEDIA OFFERED BY THE COMPANY, INCLUDING NOTICES OF CANCELLATION, POLICIES, AND PROCEDURES.</p><p><strong>Rules for Using the Vacancy Rewards Website</strong></p><p><strong>1) We May Make Changes to the Website</strong></p><p>We may periodically update or modify the website to introduce new services, enhance user experience, or align with business priorities. We will make an effort to notify you of significant changes.</p><p><strong>2) Website Availability</strong></p><p>While we strive to offer uninterrupted access to the Vacancy Rewards website, we cannot guarantee that it will always be available. Access may be temporarily suspended for maintenance or other operational reasons. We are not liable for any interruptions caused by factors beyond our control, including internet outages, system issues, or malware.</p><p>You are responsible for the necessary technology (such as an internet connection and device) to access the Vacancy Rewards Website and for ensuring that anyone accessing the Website via your connection is aware of these terms.</p><p><strong>3) Account Details:</strong> You are responsible for providing accurate and complete account information and keeping your login credentials secure and confidential. Additionally, we recommend you notify us immediately if you suspect unauthorized access. If your account is compromised by unauthorized or suspicious activity, contact us and your credit card company or bank to limit potential losses. We reserve the right to suspend or disable your account if you do not comply with these terms and conditions or if we detect suspicious activity.</p><p>4) <strong>Intellectual Property:</strong> Vacancy Rewards owns or licenses all content on the website. You may only download or print materials for personal use and must not use or modify any part of the content for commercial purposes without prior permission. Any breach of these terms and conditions regarding intellectual property will result in termination of your right to use the Vacancy Rewards Website.</p><p><strong>5) Links to Third-Party Websites:</strong> The Vacancy Rewards Website may feature links to third-party websites and resources for your convenience. We are not responsible for the content or availability of these websites, and the inclusion of links does not imply endorsement.</p><p><strong>6) Annual Subscription:</strong> To maintain access to the Vacancy Rewards platform and retain all membership benefits, your account must remain active and in good standing. The annual subscription fee must be paid in full on or before your membership anniversary date. Subscription fees are subject to change and will be communicated prior to your renewal. Failure to pay the annual subscription fee by the due date will result in the suspension of access to the platform and its associated benefits until payment is received and the account is updated.</p><p><strong>7) Prohibited Uses:</strong> You agree to use the Vacancy Rewards Website only for lawful purposes. The following activities are prohibited:</p><ul><li>Engaging in unlawful, fraudulent, or abusive behavior.  </li><li>Engaging in any way that violates any applicable local, national, or international law or regulation.  </li><li>Engaging in activities or actions to harm or attempt to harm minors in any way.  </li><li>Uploading or sharing material that contains harmful code, such as viruses or malware.  </li><li>Attempting to gain unauthorized access to any part of the Vacancy Rewards Website or related systems.  </li><li>Interfering with the proper functioning of the Vacancy Rewards Website or introducing an unreasonable data load.</li></ul><p>Violations of these rules may result in the termination of your access to the Website.</p><p><strong>General Booking Terms (apply to all travel products)</strong> </p><p><strong>a) Pricing and Details:</strong> Please ensure that all the information provided during the reservation process, such as your name, ID details, contact information, payment details, and dates, is accurate and complete. If you realize that any details provided are incorrect, we will assist you in attempting to update the booking. However, we cannot guarantee that the Supplier will allow changes, especially if the change involves a change in identity. We promote and display a large number of travel products and make every effort to ensure that the advertised price is always accurate. However, sometimes errors do occur. If the error should reasonably have been apparent to you, we reserve the right to cancel the booking or, if you agree, change the price. If this happens, we will contact you.</p><p><strong>b) Booking Process:</strong> We will send you a confirmation email when your booking is complete. You agree to check the booking confirmation details and contact us immediately if any of the details are incorrect. More information on flight and hotel booking confirmations is in the relevant sections below. We will assign a Vacancy Rewards confirmation number to your booking. It would help us if you could provide confirmation whenever you contact us about your booking.</p><p><strong>When using Vacancy Rewards reservation services, you shall not:</strong></p><ul><li>Use an invalid bank card or account you are not authorized to use.  </li><li>Do not pretend to be someone else or misrepresent your identity or connection with any individual.  </li><li>Violate any laws and regulations or regulatory requirements.</li></ul><p>All Travel Product reservations are subject to availability at the time of booking. While we try to keep our website updated, we cannot guarantee availability. We will notify you if the Travel Product you requested is not available after booking.</p><p>We may need additional information to validate your booking. If you don&#39;t provide the requested information or if we find it unsatisfactory, your booking request will be canceled. Please note that a product may become unavailable, and we will not be held liable for any loss or cost in such circumstances.</p><p><strong>Payment and Currency</strong> </p><p>1) Accepted Payment Methods: Vacancy Rewards accepts payments only through Visa, MasterCard, Discover, and Diners Club. Payments through PayPal, cash payments, money transfers, or gift cards deposited into personal accounts are not accepted under any circumstances.<br>2) Authorized Contact: Only the following Vacancy Rewards departments are authorized to contact you regarding payments: Customer Services, Reservations, Web Support, and Annual Dues Collection.<br>3) Booking Payment Terms:  Payment terms for travel bookings will be clearly outlined during the booking process. Some bookings may require full prepayment online, while others may allow payment at the time of use.<br>4) Failure to Pay: Failure to pay the required amount in full may result in immediate cancellation of the booking. Bookings may also be canceled if user activity or payment methods indicate signs of fraud or if the payment instrument is deemed invalid for any reason.<br>5) Currency and Pricing: All prices displayed on the Vacancy Rewards website are in U.S. dollars (USD). If you choose to prepay online, your account will be charged in USD, and any currency exchange rates or additional fees will depend on your financial institution.</p><p><strong>Travel Preparations</strong>: You must ensure that you have appropriate insurance and the required travel documents for your trip. These include (but are not limited to) your passport/national ID card, visas, and medical documents (such as proof of vaccinations).</p><p>When we offer travel products for a specific destination, we do not state or confirm that it is safe to travel to and/or within that destination. You are responsible for checking for any travel warnings or restrictions in the destination you are traveling to and/or around before you book and travel. </p><p>It is your responsibility to ensure that you obtain the necessary vaccinations for your trip and to follow any medical advice you have received. </p><p><strong>Vacancy Rewards User Benefits</strong></p><p>a)       <strong>Hotels</strong><br> Access to over 1 million hotels with exclusive member-only net rates, offering discounts of up to 60% off public prices.</p><p>b)      <strong>Weekly Vacation Rentals</strong><br> Thousands of resort-style accommodations for multiple guests, with 7 consecutive nights in fully equipped condos available in over 75 countries.</p><p>c)       <strong>Best Price Guarantee</strong><br> If a customer finds a better deal for the same hotel or condo within 48 hours after booking, we will match and beat the price by 5%.</p><p>d)      <strong>Exclusive Cruise Rates</strong><br> Access to over 25,000 cruise itineraries to explore the seven seas.</p><p>e)      <strong>Tours and Activities</strong><br> More than 350,000 tours and activities worldwide at net rates not available to the general public.</p><p>f)        <strong>Car Rentals</strong><br> Access discounted rates from hundreds of car rental companies with over 10,000 pickup locations.</p><p>g)       <strong>Access to Over 200 Airlines</strong><br> Experts in finding the most affordable flights on the best airlines, including low-cost carriers.</p><p>h)      <strong>Travel Packages</strong><br> Hassle-free travel planning with packages that include flights and accommodations at competitive prices.</p><p>i)        <strong>Multi-Destination Packages</strong><br> Unforgettable adventures with all-inclusive packages featuring flights, hotel stays, activities, and transfers between destinations.</p><p><strong>Hotel Bookings</strong></p><p>Your hotel booking is also subject to the hotel’s terms and conditions, which can generally be found on the hotel’s website. These terms will apply in cases of discrepancies (such as selecting a non-refundable room). You may contact the customer services department if you have any questions or concerns.</p><p><strong>Booking Process</strong></p><p>We strive to confirm your hotel booking within the time frame mentioned during the booking process. If confirmation is delayed, please contact us. Most room bookings are confirmed instantly, and your room is guaranteed once confirmed. You will receive a full refund if we cannot confirm your booking.</p><p>If you contact the hotel and they are unable to find your booking, don&#39;t worry—your booking remains valid. Hotels may not receive your personal details until closer to the booking date.</p><p><strong>Modifying, Cancelling, or Upgrading Your Hotel Booking:</strong> During the booking process, we provide information about your rights to change or cancel your hotel booking. Some lower-priced rooms may not be eligible for changes or refunds. If you&#39;re unsure of the terms, feel free to contact the customer services department.</p><p>When changes are permitted, the hotel or inventory provider may limit available hotel or room options. We’ll inform you of available options when we receive your request. If the hotel cancels or modifies your booking, its terms will apply. We will assist you through our customer service department.</p><p><strong>Hotel Ratings:</strong> Our guest ratings are based on verified reviews from users. Our star ratings are based on a combination of information, such as ratings provided directly by the hotels (including, where applicable, their star rating based on the standards in the country they are based), amenities, photos, guest reviews, and price. This is to give you the best indication of the standard of the hotel.</p><p>However, you acknowledge and agree that the star rating is an indication only; standards vary between countries, and you are responsible for reviewing all of the information provided on the hotel on our Website, to ensure that you are happy with the standard of the hotel before booking</p><p><strong>12) Resort Weeks Bookings:</strong></p><p>At Vacancy Rewards, we offer the largest selection of resort-style accommodations for multiple guests and families. Guests can stay seven consecutive nights in beautiful condo units, from studios to three bedrooms, in multiple locations worldwide. Our Resort Weeks are backed by the industry&#39;s oldest and most respected fulfillment companies.</p><p>With a daily portfolio of over 150K+ Available Resort Weeks covering more than 70 countries across all continents, we have everything your customers are looking for; pricing posted is the total amount for the entire week, which is normally the same as the maintenance fee or lower.</p><p>All Resort stays are based on availability and may be confirmed with online payment.</p><p>• <strong>Last-Minute Weeks,</strong> available from 3 to 30 days before check-in</p><p>• <strong>Smart Weeks</strong> from studios to 3-bedroom units, available up to 6 months in advance.</p><p>• <strong>VIP Weeks</strong> Real-Time availability that allows booking up to a year in advance.</p><p><strong>Cost and Availability:</strong> The cost and availability of the weeks offered may vary depending on factors such as supply and demand. These factors include inflation, the quality of the property, the size of the unit, the destination, and seasonal trends. While we strive to provide the best options, pricing and availability are subject to change based on these considerations.</p><p><strong>Modifying or Cancelling Your Booking:</strong> Once a reservation for Resort Weeks has been confirmed and paid, it is considered final. Please note that changes, cancellations, or refunds cannot be accommodated. We encourage members to carefully review their plans before completing their booking.</p><p><strong>Note:</strong> The prices displayed on the website for Resort Weeks are for accommodation only and do not include additional applicable fees such as all-inclusive plans, transportation, room surcharges, local taxes, or other additional charges. Members are responsible for covering any such fees directly with the resort or relevant service providers.</p><p><strong>13) Flight Terms</strong> </p><p><strong>AIRLINE’S TERMS AND CONDITIONS:</strong> All airline ticket reservations must be made and confirmed online by the member or by an authorized person making the reservation. Due to the many airline options and itineraries available, Vacancy Rewards agents are not permitted to make the actual booking to prevent human errors in the selection of airlines or itineraries.</p><p><strong>Please note</strong>: Your booking is subject to the <strong>airline&#39;s terms and conditions, which are</strong> generally available on the airline&#39;s website. If there are any contradictions between these terms and the airline&#39;s terms and conditions, the terms provided here will take precedence. If you have any inquiries regarding the terms and conditions associated with your flight ticket (such as rules regarding changes, cancellations, or baggage allowances), please contact the airline directly. You can also contact us via our customer support services, and we will do our best to assist you.</p><p><strong>Booking Process</strong></p><p>After your online payment is confirmed, you will receive an email from us. Please carefully review the details in the email and let us know immediately if you find any errors. We will make every effort to issue your flight ticket within the timeframe specified during your booking process. Please contact Vacancy Rewards customer services if your flight ticket has not been issued within this timeframe.</p><p>When your flight ticket is issued, you will receive a Flight Booking Confirmed email from us, including your travel itinerary and an e-receipt. If you&#39;ve selected a cheaper flight ticket, it might take a little longer for your ticket to be issued, but it will be issued no later than 72 hours before your flight. If you book a flight within three days before departure, your ticket will be issued 72 hours before departure.</p><p>When you check in for your flight, your flight ticket will be in the form of an e-ticket.</p><p>We will assign a Vacancy Rewards reservation number to your booking and inform you of it via email. Please provide the Vacancy Rewards reservation number when contacting us about your booking. Once your flight ticket is issued, we will email you the airline&#39;s booking reference or a similar identifier. If your confirmation email does not include this information, please reach out to customer service, and one of our agents will be happy to help you.</p><p><strong>Modifying or Cancelling Your Booking</strong></p><p>During your booking process, we provided information about your rights to modify or cancel your flight, as well as any associated fees. You may have chosen a lower-priced, non-refundable, or non-changeable ticket. This information is part of our terms, so please review it carefully before finalizing your booking. This same information can also be found through the link in your &quot;Flight Booking Confirmed&quot; email or by accessing your booking through our Website. Please contact the customer services department if you&#39;re unsure whether your flight is eligible for changes or refunds.</p><p>If your ticket allows changes or cancellations, you can request this by logging into your account on our Website or by reaching out to us directly. For non-account holders, you can view your booking and request modifications or refunds by entering the email used for the booking on our Website.</p><p>In the case where changes are allowed, the available flight options may be limited by the airline or ticket provider, so the choices displayed on our Website might not all apply. We will inform you of the available options once we receive your request.</p><p>If the airline cancels or modifies your flight, their terms and conditions will generally apply. Please contact us directly, and we will assist you as part of our customer service.</p><p><strong>Important Flight Details</strong></p><p>Where possible, we will provide details such as:</p><ul><li>Check-in and boarding times  </li><li>Seat selection  </li><li>Baggage allowances and restrictions  </li><li>Availability of infant/child ticket bookings online</li></ul><p><strong>However, you should always verify this information on the airline’s website.</strong></p><p>For specific information about passenger suitability (e.g., elderly, pregnant, or infant travelers), regulations on lithium batteries, hazardous materials, or liquids, or requests for special meals/services, please check the airline&#39;s website as policies may vary. If you wish to request special services or meals through us, contact us as outlined in Section 1.</p><p>It’s your responsibility to allow enough time for check-in, passport control, and security clearance at the airport. Make sure to have all required travel documents, including passports, visas, and national IDs.</p><p>Please note that your flight tickets must be used in the order specified in your itinerary. If you skip a flight (e.g., your outbound flight), the airline may cancel the remaining portion of your booking. Check with the airline for their specific policy.</p><p><strong>15) Rail Terms</strong></p><p>Your train ticket is subject to the rail operator’s terms, which were presented to you during booking.</p><p><strong>Modifying or Cancelling Your Rail Ticket.</strong></p><p>Please review the rail operator’s terms for details on changing or canceling tickets. If the rail operator changes or cancels your booking, their terms will apply. You may also contact us for support.</p><p><strong>16) Tours and Other Services (other products on our website, such as airport transfers, attraction tickets, car rentals, etc.)</strong></p><p><strong>SUPPLIER’S TERMS AND CONDITIONS</strong></p><p>All bookings for services such as car rentals, airport transfers, or attraction tickets are also subject to the provider’s terms, which are usually available on their website. If the supplier modifies or cancels your booking, their terms apply, and we are available to assist you.</p><p><strong>17) Liability</strong></p><p><strong>OUR RESPONSIBILITY FOR LOSS OR DAMAGE</strong></p><p>We strive to provide accurate and up-to-date information on the Vacancy Rewards Website. However, we cannot guarantee the availability, accuracy, or completeness of any information, products, or services third-party suppliers offer.</p><p>We make no representations, warranties, or guarantees regarding the information on our website. Any implied warranties, conditions, or representations are excluded except those that are prohibited by law.</p><p>We are not responsible for any damages or losses resulting from using the Vacancy Rewards Website, including travel disruptions, cancellations, or personal losses. Your use of the website and reliance on any information is entirely at your own risk.</p><p>To the extent permitted by law, we shall not be responsible for any loss or damage resulting from:</p><ul><li><strong>Incorrect information provided by you</strong> when making a booking (e.g., name, ID details, nationality, contact details, payment information, dates, or times). This includes but is not limited to:  <ul><li>Failure to contact you due to inaccurate contact details.  </li><li>Inability to use a travel product (e.g., boarding a plane, checking into a hotel, renting a car) because the ID details you provided do not match your documents.  </li></ul></li><li><strong>Failure to secure proper documentation</strong>, such as passports, visas, or proof of vaccinations required for your trip.  </li><li><strong>Lack of appropriate travel insurance.</strong>  </li><li><strong>Non-compliance with supplier terms and conditions,</strong> including failure to arrive on time, comply with check-in procedures, or meet behavioral standards.  </li><li><strong>Missed connections</strong> for flights, trains, buses, or ferries due to your own actions or omissions.  </li><li><strong>Invalid discount cards</strong> (e.g., railcards) for your selected journey.  </li><li><strong>Booking errors,</strong> including duplicate bookings made by you.  </li><li><strong>Bank or currency exchange fees,</strong> changes in exchange rates, or international transaction fees charged by your payment provider.  </li><li><strong>Direct communication with suppliers</strong> outside our platform.  </li><li><strong>Inaccurate guest or star ratings.</strong>  </li><li><strong>Outdated, false, or incomplete payment information provided by you.</strong>  </li><li><strong>Improper use of interactive areas</strong> on our website that violates content standards.  </li><li><strong>Traveling to areas with restrictions or warnings.</strong>  </li><li><strong>Events beyond our control</strong>, including but not limited to:  <ul><li>Natural disasters, pandemics, or epidemics.  </li><li>Acts of terrorism, war, or civil unrest.  </li><li>Government actions, sanctions, or changes in law.  </li><li>System or internet failures, viruses, or cyberattacks.</li></ul></li></ul><p>Please note that our website is intended for personal and domestic use only. By using our services, you agree not to use the website for commercial purposes. We are not liable for any loss of profit, business, or opportunities resulting from your use of the website.</p><p><strong>18) Breach of These Terms by You</strong></p><p>Failure to comply with these terms or applicable laws may result in actions taken by us at our sole discretion, including:</p><ul><li>Canceling bookings associated with your name, email, or account.  </li><li>Revoking any rewards, incentives, or benefits earned.  </li><li>Restricting or permanently removing your access to our website or booking services.  </li><li>Removing any content you have uploaded.  </li><li>Issuing warnings or initiating legal proceedings for reimbursement of costs (including administrative and legal fees).  </li><li>Disclosing information to law enforcement as required.  </li><li>Other measures deemed appropriate.</li></ul><p>If your booking is canceled due to a breach of these terms, you may not be entitled to a refund. In such cases, refunds will only be considered if you provide evidence that the cancellation was made in error.</p><p><strong>19) Complaints</strong></p><p>If you have any questions or complaints about our website or services, please use the details provided in Section 1 of these terms to contact us.</p><p><strong>20) Governing Law and Jurisdiction</strong></p><p>These terms are governed by the laws of the state of Florida. Disputes will be subject to the jurisdiction of Florida courts unless mandatory consumer rights in your country of residence are provided otherwise.</p><p><strong>21) Language</strong></p><p>In the event of inconsistencies between the English version of these terms and translations, the English version will prevail.</p><p><strong>22) General</strong></p><p>These terms are solely between you and us. No other party has the right to enforce them. If any provision is found invalid, the remainder will remain in effect. Delays in enforcement do not waive our right to act later.</p><p>These terms outline your legal responsibilities when using the Vacancy Rewards Website and booking travel services. If you have any questions, don&#39;t hesitate to contact us at <a href="mailto:support@vacancyrewards.com">support@vacancyrewards.com</a>.</p>`;

const { VUE_APP_URL_LOGIN_DEFAULT } = process.env;
import moment from "moment";
import { phone } from "phone";
import emailValidator from "email-validator";

export default {
  props: ["isDefault", "club"],
  data() {
    return {
      iso: "en",
      termsShow: false,
      cookiesShow: false,
      priceMatch: false,
      showBtnTerms: false,
      dataVerification: false,
      TERMS_ES,
      TERMS_EN,
      PRICEMATCH_EN,
      PRICEMATCH_ES,
      v: "v08102025-A",
      year: moment().format("YYYY"),
      dataUserUpdate: null,
      dataUpdate__fieldsMandatory: [
        "Nombre",
        "ApellidoPaterno",
        "Email",
        "LadaTelefono",
        "Telefono",
        "Pais",
        "Estado",
        "Nacionalidad",
        "FechaNacimiento",
        "Idioma",
      ],
      dataUpdate: {
        Nombre: null,
        ApellidoPaterno: null,
        Email: null,
        FechaNacimiento: null,
        LadaTelefono: null,
        Telefono: null,
        LadaCelular: null,
        Celular: null,
        Pais: null,
        Estado: null,
        Ciudad: null,
        Direccion: null,
        CodigoPostal: null,
        Nacionalidad: null,
        Idioma: null,
        Genero: null,
        RecibirBoletines: false,
        TerminosYCondiciones: false,
        // ContratoId: 3663749,
        // Nombre: "Soporte's",
        // ApellidoPaterno: "Genv2s",
        // Email: "jvdaza33333@gmail.com",
        // Eliminado: false,
        // Nacionalidad: "USA",
        // Idioma: "EN",
        // Password:
        //   "de49f68561c02c3ab73fb25e58bb832c0900316289acb7995a9272a2a90a7c075b60175eb6a1987695c1d2f9cda268de9279f98f95b71339d8aee93b2b24b81b",
        // TipoSocio: "T",
        // LadaTelefono: 58,
        // Telefono: "04124744530",
        // Pais: "USA",
        // Estado: "USAK",
        // Ciudad: "valenciaa",
        // Direccion: "floraa",
        // CodigoPostal: "2003",
        // FechaRegistro: 1729660090000,
        // Seal: "api",
        // Etiquetas: [],
        // __v: 0,
        // TokenAutoLogin:
        //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbWFpbCI6ImpvdGFtZXNzaUBtYWlsLmNvbSIsInBhc3N3b3JkIjoibm9wYXNzIn0.hOGkiqfKMOz8dZwEFKBP-OMlAPqaxFj1PNQ3qhhYyIs",
        // Celular: "9981589598",
        // FechaNacimiento: null,
        // LadaCelular: 52,
        // AcceptTermsWeeks: true,
        // PrimeraVezResetPassword: true,
        // TokenRecoveryPassword: 1754344901122,
        // UltimaFechaRecoveryPassword: 1754341307206,
        // FechaUltimoInicioSesion: 1758667984488,
        // TelefonoOK: "04124744530",
        // EmailOK: "jvdaza33333@gmail.com",
      },
      Cat: {
        CatPaises: [],
        CatEstadosPais: [],
        CatIdiomas: [],
      },
      showDataUpdate: false,
      showUpdatePassword: false,
      showTermsField: false,
      newpassword: null,
      isShowPass: false,
      infoResetPassword: {
        code: null,
        email: null,
      },
      btnExit: null,
      btnSave: null,
      loadingChangePassword: false,
      loadingSaveData: false,
      errorUpdateData: false,
      errorUpdateDataPhone: false,
      errorUpdateDataEmail: false,
      msgErrorUpdateData: null,
      errorTermsAccept: false,
      errorUpdatePassword: false,
      errorValidatePassword: false,
      errorInternal: false,
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
      this.$forceUpdate();
    });

    this.$bus.on("open-terms", () => {
      this.termsShow = true;
      this.showBtnTerms = true;
      this.$forceUpdate();
    });

    this.$bus.on("open-terms-withoutbtn", () => {
      this.termsShow = true;
      this.showBtnTerms = false;
      this.$forceUpdate();
    });

    this.$bus.on("cookies", () => {
      this.cookiesShow = true;
      this.$forceUpdate();
    });

    this.$bus.on("open-data-update", (info) => {
      // console.log("user", user);

      this.dataUserUpdate = info.user;
      const user = info.user;

      this.dataUpdate.Nombre = user?.Nombre || null;
      this.dataUpdate.ApellidoPaterno = user?.ApellidoPaterno || null;
      this.dataUpdate.Email = user?.Email || null;
      this.dataUpdate.FechaNacimiento = user?.FechaNacimiento
        ? moment(user?.FechaNacimiento).format("YYYY-MM-DD")
        : null;
      this.dataUpdate.LadaTelefono = user?.LadaTelefono || null;
      this.dataUpdate.Telefono = user?.Telefono || null;
      this.dataUpdate.LadaCelular = user?.LadaCelular || null;
      this.dataUpdate.Celular = user?.Celular || null;
      this.dataUpdate.Pais = user?.Pais || null;
      this.dataUpdate.Estado = user?.Estado || null;
      this.dataUpdate.Ciudad = user?.Ciudad || null;
      this.dataUpdate.Direccion = user?.Direccion || null;
      this.dataUpdate.CodigoPostal = user?.CodigoPostal || null;
      this.dataUpdate.Nacionalidad = user?.Nacionalidad || null;
      this.dataUpdate.Idioma = user?.Idioma || null;
      this.dataUpdate.Genero = user?.Genero || null;

      this.showDataUpdate = info?.DataVerification || false;
      this.showUpdatePassword =
        (info?.TokenRecoveryPassword && info?.resetPass) || false;
      this.showTermsField = info?.AcceptTermsWeeks ? false : true;

      this.btnExit = "login";
      this.btnSave = "saveData";

      this.dataVerification = true;
      this.$forceUpdate();
    });

    this.$bus.on("open-reset-pass", ({ code, email }) => {
      this.infoResetPassword.email = email;
      this.infoResetPassword.code = code;
      this.btnExit = "close";
      this.btnSave = "saveNewPass";
      this.showUpdatePassword = true;
      this.dataVerification = true;
      this.$forceUpdate();
    });

    console.log("this.$route.query", this.$route.query);

    await this.getCatalogues();

    // if (!this.iso) {
    //   this.iso = "en";
    //   this.$bus.emit("change-iso");
    //   this.$forceUpdate();
    // }
  },
  methods: {
    async acceptAllTerms(answer) {
      try {
        const { email, tokenPass, micrositePass, urlTcPass } =
          this.$route.query;
        await this.$axios.put(
          `/members/terms/check?answer=${answer ? "yes" : "no"}&email=${email}`
        );

        if (answer) {
          const URL_REDIRECT_DASHBOARD = `https://${urlTcPass}?submit=true&keepurl=true&token=${tokenPass}&microsite=${micrositePass}`;
          window.location.href = URL_REDIRECT_DASHBOARD;
        } else {
          window.location.href = `https://${VUE_APP_URL_LOGIN_DEFAULT}?token=${tokenPass}`;
        }
      } catch (error) {
        console.log("acceptAllTerms", error);
      }
    },
    async getCatalogues() {
      try {
        const list = ["CatPaises", "CatEstadosPais", "CatIdiomas"];

        for (let l of list) {
          const { data } = await this.$axios.get(`/catalogue/${l}`);
          this.Cat[l] = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateData() {
      this.errorTermsAccept = false;
      this.errorUpdatePassword = false;
      this.errorUpdateData = false;
      this.errorInternal = false;
      this.errorValidatePassword = false;
      this.errorUpdateDataPhone = false;
      this.errorUpdateDataEmail = false;

      if (this.showTermsField && !this.dataUpdate.TerminosYCondiciones) {
        this.errorTermsAccept = true;
      } else if (this.showUpdatePassword && this.newpassword === "") {
        this.errorUpdatePassword = true;
      } else if (this.showUpdatePassword && !this.validatePassword()) {
        this.errorValidatePassword = true;
      } else if (this.dataUserUpdate && !this.loadingSaveData) {
        // if (true) {
        try {
          this.loadingSaveData = true;

          const { pass, phoneValid, emailValid } = this.validateDataUpdate();

          if (pass) {
            const tmp = { ...this.dataUpdate };
            const Telefono = tmp?.Telefono;
            const Celular = tmp?.Celular;
            delete tmp.Email;
            delete tmp.Telefono;
            delete tmp.Celular;

            if (Telefono) {
              tmp.Telefono = Telefono.toString().replace(/[^0-9]/g, "");
            }
            if (Celular) {
              tmp.Celular = Celular.toString().replace(/[^0-9]/g, "");
            }

            if (this.showUpdatePassword) tmp.Password = this.newpassword;

            await this.$axios.put(
              `/catcher/members/edit/${this.dataUserUpdate?._id}?mode=websocios`,
              {
                ...tmp,
              }
            );

            this.loadingSaveData = false;

            this.exitWithoutSaving();
          }
          // else if (!emailValid) {
          //   this.loadingSaveData = false;
          //   this.errorUpdateDataEmail = true;
          // }
          else if (!phoneValid) {
            this.loadingSaveData = false;
            this.errorUpdateDataPhone = true;
          } else {
            this.loadingSaveData = false;
            this.errorUpdateData = true;
          }
        } catch (error) {
          this.loadingSaveData = false;
          this.errorInternal = true;
          console.log(error);
        }
      }
    },
    checkPassRegex(validation) {
      if (validation === 1 && this.newpassword) {
        const len = this.newpassword.length;
        return len >= 8 ? true : false;
      } else if (validation === 2 && this.newpassword) {
        return /[a-z]/.test(this.newpassword);
      } else if (validation === 3 && this.newpassword) {
        return /[A-Z]/.test(this.newpassword);
      } else if (validation === 4 && this.newpassword) {
        return /[0-9]/.test(this.newpassword);
      } else if (validation === 5 && this.newpassword) {
        return /[^a-zA-Z0-9\s]/.test(this.newpassword);
      } else if (validation === 6 && this.newpassword) {
        return /\s/.test(this.newpassword) ? false : true;
      } else {
        return false;
      }
    },
    exitWithoutSaving() {
      this.dataVerification = false;
      this.$bus.emit("return-dashboard");
    },
    async changePasswordManual() {
      this.errorValidatePassword = false;
      this.errorInternal = false;

      if (this.validatePassword() && !this.loadingChangePassword) {
        try {
          this.loadingChangePassword = true;
          // this.errorChangePassword = false;
          // this.notMatchPassword = false;
          // this.errorChangePasswordInternal = false;

          const code = this.infoResetPassword.code;
          const newpassword = this.newpassword;
          const email = this.infoResetPassword.email;

          await this.$axios.post(`/recovery-password/members/change`, {
            code,
            password: newpassword,
            email,
          });

          this.dataVerification = false;
          this.$bus.emit("login-no-otp", {
            email,
            newpass: newpassword,
            code,
          });

          // this.alert.title = this.$func.parseIso("resetPasswordOk");
          // this.alert.close = this.goToDashboard;
          // this.openAlert();

          this.loadingChangePassword = false;
        } catch (error) {
          this.loadingChangePassword = false;
          this.errorInternal = true;
          // const code = error?.response?.data?.code;
          // if (code && code === 4041) this.errorChangePassword = true;
          // else this.errorChangePasswordInternal = true;
          console.log(error);
        }
      } else {
        this.errorValidatePassword = true;
      }
    },
    validateDataUpdate() {
      let pass = true;
      let phoneValid = true;
      let emailValid = true;

      for (let field of this.dataUpdate__fieldsMandatory) {
        if (!this.dataUpdate[field] || this.dataUpdate[field] === "") {
          pass = false;
        }
      }

      //Validamos el telefono y celular
      if (this.dataUpdate.LadaTelefono && this.dataUpdate.Telefono) {
        const phoneCheck = phone(
          `+${this.dataUpdate.LadaTelefono}${this.dataUpdate.Telefono}`
        );
        if (!phoneCheck || !phoneCheck?.isValid) {
          pass = false;
          phoneValid = false;
        }
      }

      // if (this.dataUpdate.LadaCelular && this.dataUpdate.Celular) {
      //   const phoneCheck = phone(
      //     `+${this.dataUpdate.LadaCelular}${this.dataUpdate.Celular}`
      //   );
      //   if (!phoneCheck || !phoneCheck?.isValid) {
      //     pass = false;
      //     phoneValid = false;
      //   }
      // }

      // if (this.dataUpdate.Email) {
      //   const emailCheck = emailValidator.validate(this.dataUpdate.Email);
      //   if (!emailCheck) {
      //     pass = false;
      //     emailValid = false;
      //   }
      // }

      return { pass, phoneValid, emailValid };
    },
    validatePassword() {
      let pass = true;
      const vald = [1, 2, 3, 4, 5, 6];
      for (let v of vald) {
        const tmp = this.checkPassRegex(v);
        if (!tmp) pass = false;
      }
      return pass;
    },
    reloadTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
.original-button {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-decoration: none;
  color: #ffffff;
  font-size: 18px;
  border-radius: 10px;
  /* width: 200px; */
  height: 40px;
  font-weight: bold;
  transition: 0.3s;

  cursor: pointer;
}
.original-button:hover {
  opacity: 0.7;
}

.cancel-terms {
  background-color: #f14668;
}
.accept-terms {
  background-color: #0472aa;
}
.close-terms {
  background-color: #888888;
}

.select-custom {
  box-shadow: none !important;
  border: 1px solid #e3e3e3 !important;
}

.select-custom:focus {
  box-shadow: none !important;
  border: 1px solid #e3e3e3 !important;
}

/* Variables de colores para fácil personalización */
:root {
  --primary-color: #007bff; /* Un azul vibrante, común para acciones */
  --border-color: #d1d5db; /* Gris claro para bordes */
  --text-color: #374151; /* Gris oscuro para el texto principal */
  --placeholder-color: #eeeeee; /* Gris para el texto de relleno */
  --focus-ring-color: rgba(
    0,
    123,
    255,
    0.25
  ); /* Anillo de enfoque translúcido */
}

.currency-container {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-color);
  /* border-radius: 8px;  */
  overflow: hidden;
  background-color: #ffffff;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);  */
  transition: border-color 0.2s, box-shadow 0.2s; /* Transición suave en el borde y la sombra */
}

.currency-select {
  border: 1px solid #e3e3e3 !important;
  background-color: #f9fafb; /* Fondo ligeramente gris para distinguirlo */
  padding: 10px 14px;
  font-size: 1rem; /* Usar rem para mejor escalabilidad */
  color: var(--text-color);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  /* border-right: 1px solid var(--border-color); */
  transition: background-color 0.2s;
}

/* Estado de hover y focus para el select */
.currency-select:hover {
  background-color: #e5e7eb;
}

.currency-select:focus {
  outline: none;
  background-color: #e5e7eb;
}

.currency-input {
  flex-grow: 1;
  border: 1px solid #e3e3e3 !important;
  padding: 10px 0px 10px 10px;
  font-size: 1rem;
  color: var(--text-color);
  background-color: #ffffff;
  transition: background-color 0.2s;
}

.currency-input::placeholder {
  /* color: var(--placeholder-color); */
  color: #d1d1d1;
}

.currency-input:focus {
  outline: none;
  background-color: #f9fafb; /* Fondo ligero cuando está en foco */
}

padding-r-important {
  padding-right: 10px !important;
}

#emailUpdateData:disabled {
  background-color: #efefef !important;
  /* color: #9ca3af !important; */
}

#zipUpdateData::placeholder {
  /* color: var(--placeholder-color); */
  color: #d1d1d1;
}

.ul-pass {
  list-style-type: none; /* Esto remueve los puntos predeterminados de la lista */
  padding: 0;
}
.li-pass {
  /* font-size: 1.2em; */
  padding: 2px 0;
}
.icon-pass {
  margin-right: 1px; /* Esto da un espacio entre el icono y el texto */
}

.center-all {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

/* OTP */
.input-div-tw {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.input-field-tw {
  height: 3.5rem;
  width: 3.5rem;
  border-width: 1px;
  border-color: transparent;
  background-color: rgb(241, 245, 249);
  text-align: center;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 800;
  color: rgb(15, 23, 42);
}
.input-field-tw:hover {
  border-color: rgb(226, 232, 240);

  appearance: none;
  border-radius: 0.25rem;
  padding: 1rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.input-field-tw:focus {
  border-color: rgb(129, 140, 248);
  background-color: rgb(255, 255, 255);
  box-shadow: 0 0 0 0px #fff, 0 0 0 calc(2px + 0px) rgb(59, 130, 246, 0.5),
    0 0 #0000;
}

.input-btn-tw {
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  max-width: 260px;
}

.input-link-tw {
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgb(100, 116, 139);
}

.input-sublink-tw {
  font-weight: 500;
  color: rgb(99, 102, 241);
}
.input-sublink-tw:hover {
  color: rgb(79, 70, 229);
}
.input-error-tw {
  color: rgb(241, 100, 100);
  font-weight: 600;
  margin-top: 20px;
  text-align: center;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Oculta el checkbox original */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Crea un indicador de checkbox personalizado */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
}

/* Cuando el mouse pasa sobre el checkbox, cambia el color de fondo */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* Cuando el checkbox está marcado, cambia el color de fondo */
.checkbox-container input:checked ~ .checkmark {
  background-color: #4caf50; /* Un verde vibrante */
}

/* Crea el "check" (marca de verificación) del checkbox */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Muestra el "check" cuando el checkbox está marcado */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Estilo del "check" */
.checkbox-container .checkmark:after {
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.loader-spn {
  /* font-weight: bold; */
  /* font-family: sans-serif; */
  /* font-size: 30px; */
  animation: l1 2s linear infinite alternate;
}

@keyframes l1 {
  to {
    opacity: 0;
  }
}
</style>
